var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100, _g101, _g102, _g103, _g104, _g105, _g106, _g107, _g108, _g109, _g110, _g111, _g112, _g113, _g114, _g115, _g116, _g117, _g118, _g119, _g120, _g121, _g122, _g123, _g124;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampfire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1800 1500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #d67347;\n      }\n\n      .st1, .st2, .st3, .st4, .st5, .st6 {\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n      }\n\n      .st1, .st2, .st3, .st4, .st6 {\n        stroke: #000;\n      }\n\n      .st1, .st2, .st4 {\n        stroke-width: 2px;\n      }\n\n      .st1, .st3, .st5, .st6 {\n        fill: none;\n      }\n\n      .st2, .st7 {\n        fill: #fff;\n      }\n\n      .st8 {\n        fill: #be5521;\n      }\n\n      .st9 {\n        fill: #f4e211;\n      }\n\n      .st10 {\n        fill: #e5d11a;\n      }\n\n      .st11 {\n        fill: #db955d;\n      }\n\n      .st12 {\n        fill: #69ad3d;\n      }\n\n      .st13 {\n        fill: #ffbe9f;\n      }\n\n      .st14 {\n        fill: #9b3512;\n      }\n\n      .st15 {\n        clip-path: url(#clippath-17);\n      }\n\n      .st16 {\n        clip-path: url(#clippath-19);\n      }\n\n      .st17 {\n        clip-path: url(#clippath-16);\n      }\n\n      .st18 {\n        clip-path: url(#clippath-10);\n      }\n\n      .st19 {\n        clip-path: url(#clippath-15);\n      }\n\n      .st20 {\n        clip-path: url(#clippath-13);\n      }\n\n      .st21 {\n        clip-path: url(#clippath-12);\n      }\n\n      .st22 {\n        clip-path: url(#clippath-61);\n      }\n\n      .st23 {\n        clip-path: url(#clippath-67);\n      }\n\n      .st24 {\n        clip-path: url(#clippath-68);\n      }\n\n      .st25 {\n        clip-path: url(#clippath-60);\n      }\n\n      .st26 {\n        clip-path: url(#clippath-62);\n      }\n\n      .st27 {\n        clip-path: url(#clippath-64);\n      }\n\n      .st28 {\n        clip-path: url(#clippath-66);\n      }\n\n      .st29 {\n        clip-path: url(#clippath-63);\n      }\n\n      .st30 {\n        clip-path: url(#clippath-76);\n      }\n\n      .st31 {\n        clip-path: url(#clippath-78);\n      }\n\n      .st32 {\n        clip-path: url(#clippath-75);\n      }\n\n      .st33 {\n        clip-path: url(#clippath-79);\n      }\n\n      .st34 {\n        clip-path: url(#clippath-50);\n      }\n\n      .st35 {\n        clip-path: url(#clippath-52);\n      }\n\n      .st36 {\n        clip-path: url(#clippath-57);\n      }\n\n      .st37 {\n        clip-path: url(#clippath-56);\n      }\n\n      .st38 {\n        clip-path: url(#clippath-53);\n      }\n\n      .st39 {\n        clip-path: url(#clippath-70);\n      }\n\n      .st40 {\n        clip-path: url(#clippath-77);\n      }\n\n      .st41 {\n        clip-path: url(#clippath-74);\n      }\n\n      .st42 {\n        clip-path: url(#clippath-71);\n      }\n\n      .st43 {\n        clip-path: url(#clippath-73);\n      }\n\n      .st44 {\n        clip-path: url(#clippath-72);\n      }\n\n      .st45 {\n        clip-path: url(#clippath-51);\n      }\n\n      .st46 {\n        clip-path: url(#clippath-58);\n      }\n\n      .st47 {\n        clip-path: url(#clippath-59);\n      }\n\n      .st48 {\n        clip-path: url(#clippath-31);\n      }\n\n      .st49 {\n        clip-path: url(#clippath-32);\n      }\n\n      .st50 {\n        clip-path: url(#clippath-33);\n      }\n\n      .st51 {\n        clip-path: url(#clippath-34);\n      }\n\n      .st52 {\n        clip-path: url(#clippath-35);\n      }\n\n      .st53 {\n        clip-path: url(#clippath-39);\n      }\n\n      .st54 {\n        clip-path: url(#clippath-30);\n      }\n\n      .st55 {\n        clip-path: url(#clippath-36);\n      }\n\n      .st56 {\n        clip-path: url(#clippath-37);\n      }\n\n      .st57 {\n        clip-path: url(#clippath-38);\n      }\n\n      .st58 {\n        clip-path: url(#clippath-27);\n      }\n\n      .st59 {\n        clip-path: url(#clippath-29);\n      }\n\n      .st60 {\n        clip-path: url(#clippath-26);\n      }\n\n      .st61 {\n        clip-path: url(#clippath-28);\n      }\n\n      .st62 {\n        clip-path: url(#clippath-20);\n      }\n\n      .st63 {\n        clip-path: url(#clippath-21);\n      }\n\n      .st64 {\n        clip-path: url(#clippath-22);\n      }\n\n      .st65 {\n        clip-path: url(#clippath-23);\n      }\n\n      .st66 {\n        clip-path: url(#clippath-24);\n      }\n\n      .st67 {\n        clip-path: url(#clippath-25);\n      }\n\n      .st68 {\n        clip-path: url(#clippath-69);\n      }\n\n      .st69 {\n        clip-path: url(#clippath-41);\n      }\n\n      .st70 {\n        clip-path: url(#clippath-42);\n      }\n\n      .st71 {\n        clip-path: url(#clippath-43);\n      }\n\n      .st72 {\n        clip-path: url(#clippath-44);\n      }\n\n      .st73 {\n        clip-path: url(#clippath-45);\n      }\n\n      .st74 {\n        clip-path: url(#clippath-49);\n      }\n\n      .st75 {\n        clip-path: url(#clippath-40);\n      }\n\n      .st76 {\n        clip-path: url(#clippath-46);\n      }\n\n      .st77 {\n        clip-path: url(#clippath-47);\n      }\n\n      .st78 {\n        clip-path: url(#clippath-48);\n      }\n\n      .st79 {\n        clip-path: url(#clippath-85);\n      }\n\n      .st80 {\n        clip-path: url(#clippath-86);\n      }\n\n      .st81 {\n        clip-path: url(#clippath-87);\n      }\n\n      .st82 {\n        clip-path: url(#clippath-80);\n      }\n\n      .st83 {\n        clip-path: url(#clippath-81);\n      }\n\n      .st84 {\n        clip-path: url(#clippath-82);\n      }\n\n      .st85 {\n        clip-path: url(#clippath-83);\n      }\n\n      .st86 {\n        clip-path: url(#clippath-84);\n      }\n\n      .st87 {\n        fill: #f5f1e5;\n      }\n\n      .st88 {\n        fill: #2ca0ff;\n      }\n\n      .st89 {\n        clip-path: url(#clippath-1);\n      }\n\n      .st90 {\n        clip-path: url(#clippath-3);\n      }\n\n      .st91 {\n        clip-path: url(#clippath-4);\n      }\n\n      .st92 {\n        clip-path: url(#clippath-2);\n      }\n\n      .st93 {\n        clip-path: url(#clippath-7);\n      }\n\n      .st94 {\n        clip-path: url(#clippath-6);\n      }\n\n      .st95 {\n        clip-path: url(#clippath-9);\n      }\n\n      .st96 {\n        clip-path: url(#clippath-8);\n      }\n\n      .st97 {\n        clip-path: url(#clippath-5);\n      }\n\n      .st98 {\n        fill: #efa96f;\n      }\n\n      .st99 {\n        fill: #a03510;\n      }\n\n      .st100 {\n        fill: #f9b564;\n      }\n\n      .st5 {\n        stroke: #f5f1e5;\n      }\n\n      .st101 {\n        fill: #ebc2ff;\n      }\n\n      .st102 {\n        fill: #f7ad77;\n      }\n\n      .st103 {\n        fill: #ad4112;\n      }\n\n      .st6 {\n        stroke-width: 3px;\n      }\n\n      .st104 {\n        fill: #d37f46;\n      }\n\n      .st105 {\n        fill: #e1b7f9;\n      }\n\n      .st106 {\n        fill: #ff715d;\n      }\n\n      .st107 {\n        fill: #8dd463;\n      }\n\n      .st108 {\n        fill: #b24c1f;\n      }\n\n      .st109 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M278.63,1297.34s41.94,27.71-5.14,50.26c0,0-39.25-20.79,5.14-50.26Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M278.54,1297.25s-15.45-70.49-82.47-35.15c0,0,20.26,67.95,82.47,35.15Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1581.48,1278.25s14.07-48.26,49.53-9.95c0,0-8.26,43.64-49.53,9.95Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M1639.37,910.07l-483.04-238.14c-45.95-22.65-58.36-83.25-23.96-121.2.62-.68,1.25-1.36,1.88-2.02,21.97-22.92,48.97-29.15,68.5-30.18,13.74-.72,27.41,2.31,39.63,8.65,153.46,79.62,306.92,159.25,460.39,238.87l-63.4,144.02Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M1286.39,1160.45l309.7-113.01c41.08-14.99,87.04,5.47,102.41,46.4.29.77.57,1.54.84,2.33.85,2.42,1.6,4.82,2.25,7.2,11.14,40.35-11.4,82.38-50.87,96.33-111.53,39.41-223.06,78.82-334.58,118.23l-29.75-157.47Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M586.97,1168.29l-315.16-115.62c-37.44-13.73-79.4,3.68-95.48,40.17-.37.85-.74,1.71-1.1,2.58-16.08,38.94,3.46,83.5,42.65,98.96l325.02,128.25,44.08-154.35Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 140.29,
    cy: 829.12,
    rx: 87.78,
    ry: 95.21
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 580.62,
    cy: 1250.34,
    rx: 79.7,
    ry: 82.05
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1292.6,
    cy: 1243.12,
    r: 81.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 1682.5,
    cy: 843.2,
    rx: 77.28,
    ry: 79.93
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M1581.42,1278.37s-62.77,35.6-9.19,89.17c0,0,58.92-39.45,9.19-89.17Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M856.13,250.79l104.65-3.63c3.23.7,44.03,10.23,59.36,49.72,12.28,31.62-.65,59.61-2.96,64.42-8.54,32.41-17.07,64.82-25.61,97.22,0,0-76.34,19.3-150.68-10.61,0,0-26.11-33.12-10.79-88.15-2.5-3.26-20.55-27.67-13.11-60.08,7.61-33.14,35.59-47.19,39.14-48.89Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M974.6,488.82s-26.82-13.65,3.05-46.59c11.14-12.28,27.05-19.42,43.62-18.79,12.88.49,27.44,5.51,38.66,21.74,13.12,18.98,4.87,45.16-16.92,52.74-.29.1-.58.2-.87.29,0,0-28,45.49-47.02,12.55,0,0-25.62,3-20.52-21.95Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M884.9,216.1c2.18,17.93,17.27,27.7,26.76,25.36,9.31-2.3,17.97-17.42,12.3-34.04l-39.06,8.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M862.83,271.91l20.62-37.64c1.13-2.07,3.38-3.27,5.73-3.05l32.52,2.93c3.67.33,6.15,3.9,5.19,7.45l-12.28,45.26c-.85,3.13-4.06,5-7.2,4.19l-40.86-10.55c-3.74-.97-5.57-5.19-3.72-8.58Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M870.32,338.18c-2.32,25.71-25.83,42.43-46.62,38.23-16.95-3.42-30.58-20.44-30.39-40.82.06-6.77,1.04-29.59,18.16-50.1,8.29-9.94,20.37-19.14,37.93-25.14,28.83-6.92,51.86-2.17,57.24,9.83,1.09,2.43,1.97,6.32.38,12.25.71.33,7.99,3.94,9.41,12.23,1.19,6.92-2.57,12.04-3.23,12.9,1.15.78,5.63,4.02,5.99,9.08.29,4.08-2.25,7.17-3.53,8.73-9.07,11.04-42.01,12.66-45.35,12.81Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M726.48,736.75s-13.13,69.77,55.54,69.77c0,0,48.9.55,75.29-28.2,8.28-9.02,10.3-22.35,4.26-32.99-4.54-8-13.92-15.27-32.86-16.1-5.41-.24-10.75-1.53-15.47-4.17-6.05-3.38-12.4-9.43-13.57-20.12-2.34-21.37,0,0,0,0-12.35-12.03-30.66-15.64-46.46-9.19-16.43,6.71-27.11,23.07-26.73,41"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M695.55,496.14c14.82-4.87,33.67-3.54,53.09,17.55,10.12,10.99,17.36,24.3,21.48,38.65,7.78,27.12,23.52,87.67,29.55,152.59,0,0-21.07,39.17-73.19,31.82l-53.12-140.28s-11.93-22.49-12.82-48.85c-.77-23.01,13.13-44.3,35-51.48Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M574.13,727.69s-16.91,29.96-16.14,62.63c.23,9.83,5.62,18.83,14.12,23.78,25.82,15.03,86.64,44.55,121.73,13.18,10.89-9.74,12.47-26.41,2.99-37.52-4-4.68-10.16-9.05-19.53-12.25l-22.69-11.21s-9.87-7.63-13.73-21.69c-3.86-14.06,0,0,0,0-2.6-14.42-13.28-26.09-27.34-29.88-14.45-3.9-29.97,1.21-39.39,12.97"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M656.03,759.13s-.15-.02-.42-.05c-17.85-1.78-24.71,22.69-8.59,30.58,13.63,6.67,32.43,10.55,48.36-5.39l-39.34-25.14Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M593.74,547.83s-35.27,40.16-19.61,179.86c3.04,3.77,12.99,15.14,30.54,19.59,17.55,4.45,31.72-.81,36.19-2.68,11.5-12.33,30.09-47.73,47.43-96.63,17.86-50.4,24.03-104.95-22.77-121.59-23.93,7.15-47.85,14.3-71.78,21.45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M665.52,330.91s-24.45,37.08-14.09,106.67c3.67,24.66,25.29,43.08,50.19,42.03.61-.03,1.22-.06,1.84-.11,7.19-.55,13.45-2.51,18.77-5.1,12.61-6.14,22.17-17.15,27.07-30.29,2.77-7.43,5.17-16.01,6.41-25.65,2.81-21.9.82-52.13-17.9-86.3-2.26-4.13-5.07-7.97-8.53-11.17-8.9-8.23-20.9-12.36-32.91-10.91-19.93,2.4-29.79,18.96-30.86,20.83Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M543.94,307.2c-23.64,1.22-42.71,19.2-44.91,41.31-2.38,23.9,15.57,46.54,41,50.06,5.21,39.47,10.43,78.93,15.64,118.4,0,0,60.53,4.23,95.05-45.32,0,0,17.26-39.13,13.07-108.84,1.16-1.15,6.09-16.16,3.32-29.83-2.87-14.2-19.66-25.59-39.47-22.84-27.9-.98-55.81-1.97-83.71-2.95Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M630.29,542.95c-18.48,11.55-41.74,7.11-52.86-8-4.65-6.31-6.9-14.12-6.72-22.14.25-11.23,5.67-21.65,14.12-29.05,3.23-2.83,7.04-5.53,11.57-7.71,13.77-6.64,35.39-10.28,66.77,1.7,0,0,55.3,30.3,25.18,54.75,0,0,2.04,18.29-14.99,15.73,0,0-1.2,17.27-14,15.01-4.04-.71-7.5-3.29-9.64-6.79-4.17-6.8-13.28-19.63-19.43-13.49Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M603.46,280.37c6.36,13.65,17.64,19.82,23,17.48,5.47-2.39,8.75-15.4,2.16-29.81-8.39,4.11-16.78,8.22-25.16,12.33Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M620.56,296.03l22.67-16.83c2.26-1.68,5.15-2.24,7.87-1.55l44.59,11.42c6.15,1.57,8.96,8.7,5.55,14.05l-20.83,32.66c-2.7,4.23-8.25,5.57-12.58,3.03l-46.44-27.24c-5.76-3.38-6.21-11.55-.84-15.53Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M664.01,299.8s-11.77-18.67,11.41-27.35c12.84-4.8,27.23-3.99,39.36,2.4,6.55,3.45,13.37,8.84,18.45,17.23,11.11,18.35,5.51,37.17,4.6,40.08-4.47,14.89-17.15,25.82-32.26,27.82-11.73,1.55-23.49-2.46-32.01-10.59-5.78-5.52-6.67-14.68-1.49-20.77.22-.25.44-.5.67-.74,5.72-5.92,13.66-4.7,14.35-4.58-1.02-.24-2.71-.77-4.21-2.18-1.65-1.54-3.16-4.15-3.16-8.53,0,0-14.62,2.35-15.71-12.77Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-30"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st8",
    cx: 531.71,
    cy: 284.33,
    rx: 13.86,
    ry: 11.98
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M135.62,643.92c-32.86,25.93-47.43,67.06-36.83,101.7,14.13,46.16,71.68,76.65,128.92,57.81,6.86,37.42,43.86,60.09,76.48,51.68,33.86-8.72,55.36-48.94,40.68-85.66-4.93-23.31-9.87-46.61-14.8-69.92-4.9-23.14-9.8-46.29-14.7-69.43-59.92,4.6-119.83,9.21-179.75,13.81Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M365.24,423.3c-18.02,11.94-28.86,33.13-30.61,54.68s4.94,43.25,16.26,61.67c11.31,18.42,27.05,33.79,44.12,47.06,16.4,12.75,34.7,23.94,55.12,27.75,22.7,4.24,47.13-1.39,65.48-15.4s30.25-36.26,31.38-59.32c1.51-30.89-15.68-60.34-38.83-80.84-35.55-31.48-97.09-65.96-142.9-35.6Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M256.77,407.4s-70.59,19.97-114.36,74.17c-21.39,26.48-14.95,66.26,14.29,83.68,3,1.79,6.18,3.32,9.53,4.56,24.86,9.21,53.57.49,69.71-21.59,1.44,4.86,2.82,10.26,3.62,16.2,1.4,10.4,2,25.4-1.25,43.8,0,0,32.6,15.89,58.14,41.44,0,0,47.12,1.19,69.43-37.45,0,0,10.31-24.97,10.31-52.94,4.29-.65,30.72-5.1,45.87-28.98,7.24-11.41,10.38-24.85,9.48-38.37-1.13-16.94-8.91-32.75-21.18-44.49-7.49-7.17-16.55-14.45-27.39-21-52.1-31.42-107.46-22.82-126.21-19.01Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M111.85,636.16c-13.69-38.96,14.39-80.62,55.68-81.48.69-.01,1.37-.02,2.06-.01,31.36.29,59.64,22.04,68.72,53.55,7.52.16,20.14,1.45,33.86,8.14,3.04,1.48,5.85,3.09,8.46,4.78,24.93,16.17,32.23,49.83,15.11,74.12-.39.55-.79,1.11-1.21,1.66-21.54,28.55-57.68,26.49-60.41,26.29-11.62-.09-48.68-1.84-82.24-29.23-21.7-17.72-33.56-39.33-40.05-57.81Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M268.62,409.66c-.48-2.05-1.46-7.5,1.01-13.61.02-.04.04-.09.05-.13,1.99-4.83,7.03-7.62,12.23-7.11,3.85.38,8.08-.02,11.23-2.38,5.05-3.78,7.35-10.52,5.87-17.02-.82-3.6-.04-7.39,2.4-10.17,1.41-1.61,3.3-3.21,5.78-4.42,1.93-.94,3.82-1.45,5.53-1.69,3.52-.5,7.02.67,9.78,2.91,7.14,5.82,16.29,6.7,22.35,2.71,4.2-2.76,5.94-7.22,6.65-10.03.6-2.35,1.89-4.5,3.85-5.94,1.1-.8,2.46-1.53,4.11-1.91,4.84-1.14,10.15,1.06,13.38,5.59,7.73-.63,13.6-6.8,13.86-13.65.3-7.92-6.94-15.29-16.02-14.78.22-1.04,2.57-13.12-6.13-22.2-6.46-6.74-16.43-9.15-25.58-6.19-9.55-13.84-26.96-20.09-43.1-15.5-16.25,4.63-27.78,19.28-28.47,36.21-10.65-1.94-21.46,1.94-27.98,10.15-7.59,9.55-8.11,23.37-1.1,34.09-9.14,7.87-13.33,20.08-10.89,31.82,2.52,12.16,11.76,21.92,23.83,25.2,1.78,4.97,6.92,7.54,11.22,6.23,3.35-1.02,5.84-4.3,6.15-8.2Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-36"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st106",
    cx: 247.66,
    cy: 284.46,
    rx: 15.08,
    ry: 20.81,
    transform: "translate(-121.3 206.18) rotate(-36.98)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.7,409.69c3.46,18.14,13.88,28.87,20.09,27.82,6.09-1.03,12.16-14.12,10.17-31.58-10.09,1.25-20.17,2.51-30.26,3.76Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M398.97,414.77l41.93,15.1c6.19,2.23,9.52,8.96,7.52,15.23l-8.83,27.82c-2.21,6.96-9.99,10.46-16.66,7.48l-56.84-25.32c-8.57-3.82-9.84-15.45-2.31-21.03l23.74-17.6c3.29-2.44,7.59-3.07,11.45-1.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M461.32,510.79c7.7,18.62,26.24,30.2,45.45,28.75,21.51-1.63,39.5-19.26,41.73-41.92.68-6.76,2.55-31.34-13.75-55.11-9.25-13.5-24.38-26.36-48.96-34.39,0,0-46.1-19.69-71.67,3.5,0,0-20.88,26.26-5.06,44.3,0,0-5.32,13.45,12.59,18.95,0,0-4.69,10.63,11.39,16.91,5.14,2.01,10.7,2.72,16.2,2.35l9.7-.66s-7.51.2,2.38,17.32Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-40"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st8",
    cx: 474.4,
    cy: 787.17,
    rx: 65.46,
    ry: 69.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M442.25,765.4c2.62-.15,20.68-1.51,30.63-16.31,3.89-5.79,5.19-11.64,5.66-15.52,11.16,7.01,24.95,7.33,35.04.59,11.57-7.73,13.13-20.98,13.33-22.91.08-.85,1.15-13.94-9.09-21.9-7.92-6.15-19.24-6.63-28.24-1.08-2.87-10.49-11.05-18.61-21.29-20.98-12.02-2.79-24.91,2.8-31.6,13.94-14.38-7.54-31.9-5.91-44.54,4.14-12.93,10.28-18.41,27.5-13.8,43.47-27.01,15.99-38.07,46.42-28.67,69.72,6.35,15.74,21.94,28.02,39.74,30.19,21.94,2.68,43.39-10.45,49.92-25.57.05-.12.11-.24.16-.37,7.17-16.94,4.07-32.22,2.77-37.44Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-42"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 435.91,
    cy: 789.51,
    r: 14.63
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M517.2,790.98c3.72,11.21,8.61,19.75,12.37,19.29,4.08-.5,7.09-11.6,7.22-27.25-6.53,2.65-13.06,5.31-19.59,7.96Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.27,674.23c-8.48,1.3-15.86,6.63-21.73,12.89s-10.53,13.55-15.96,20.19c-5.43,6.64-11.89,12.82-19.94,15.79-11.04,4.07-23.4,1.56-34.53-2.25-11.14-3.81-22.03-8.92-33.74-10.05-15.32-1.48-30.78,4.15-43.08,13.4-12.3,9.25-21.68,21.9-29.17,35.34-8.79,15.75-15.29,33.29-15.1,51.33s7.89,36.61,22.76,46.82c14.88,10.2,37.12,9.9,49.71-3.02,18.9-19.41,10.43-56.32,31.59-73.24,10.36-8.28,24.65-8.88,37.87-9.95s27.81-3.78,35.78-14.39c6.06-8.06,6.78-18.76,9.21-28.55,2.08-8.39,6.75-18.15,15.52-21.16,8.34-2.85,18.33,3.32,26.25-1.28,18.41-10.69,2.43-34.62-15.44-31.88Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M676.06,1230.92s3.9,99.58,83.4,52.04l80.87-50.25c11.05-6.86,19.33-17.53,22.72-30.09,2.65-9.82,2.53-21.2-6-30.95s-22.78-13.59-35.48-9.67l-57.4,17.7c-19.76-15.66-47.1-16.54-66.52-2.66-16.64,11.9-25.03,32.89-21.59,53.87"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M795.84,1194.49c6.14-.32,11.98-2.62,17.66-4.97,7.23-3,14.75-6.41,19.38-12.73s5.02-16.42-1.24-21.14c-3.78-2.85-8.89-3.08-13.61-2.7-12.86,1.01-31.8,6.34-40.29,17-9.43,11.84,6.58,25.15,18.1,24.55Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-47"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M306.16,1062.96s-36.58,77.14,51.59,128.47c27.33,15.91,58.4,24.36,90.02,24.91,57.94,1,156.77-17.99,230.06-140.5,25.03-41.83-6.44-94.9-55.14-92.87-22.65.94-51.59,7.19-88.54,22.06l-228,57.92Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M664.84,902.24s10.46,50.45-15.69,91.77c-27.65,43.7-93.08,36.01-108.66-13.52,0,0,0-.01,0-.02-.47-1.5-.74-3.06-.86-4.63-.92-12.17-2.42-64.77,37.44-90.26,0,0,29.9,23.41,87.77,16.65Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M548.05,789.12l59.65,19.63c3.16,1.04,5.2,4.12,4.91,7.44l-2.95,33.83c-.42,4.85-5.46,7.88-9.95,5.98l-69.46-29.41c-3.88-1.64-5.51-6.25-3.54-9.97l12.76-24.05c1.64-3.09,5.26-4.55,8.58-3.45Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-50"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1081.8,763.71l-.2,1.45s-76.59,10.34-71.54,46.22c0,0,15.54,34.17,83.67,21.12l57.82-15.48c12.03-3.22,19.78-14.9,18.07-27.24l-3.12-22.43c-.25-1.82-.6-3.62-1.11-5.39-5.23-18.1-20.48-31.43-38.56-33.61-.59-.07-1.17-.13-1.76-.18-21.46-1.71-40.35,14.2-43.27,35.53Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-51"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1151.33,791.23s-1.45,7.13-15.77,9.5c0,0-85.35,4.66-85.35,57.46,0,0-2.36,37.72,105.93,26.31l36.66-5.36c20.81-3.04,37.73-18.45,42.49-38.93.7-3.02,1.35-6.15,1.93-9.38,3-16.66,3.37-31.31,2.84-42.79-5.24-19.33-21.53-33.26-40.14-34.8-22.11-1.82-43.57,14.19-48.59,37.99"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-52"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M1081.82,821.1c-4.77,1.9-9.95,4.56-11.67,9.64-2.19,6.48,2.53,13.5,8.21,16.86,6.77,4,14.92,4.72,22.6,3.58,7.68-1.14,15.02-4.03,22.28-6.89,7.03-2.77,15.14-6.89,16.2-14.76.76-5.7-2.9-11.3-7.68-14.05-14.56-8.37-35.8,0-49.94,5.62Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-53"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M1689.42,651.59s112.06,127.55-123.28,150.92c0,0,5.53,59.51-12.04,132.16l-221.62-16.86c-7.32-47.26-14.63-94.53-21.95-141.79-14.11-45.53-3.14-92.56,28.06-119.58,22.86-19.8,49.67-22.86,61.34-23.43l121.07,20.15,168.42-1.56Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-56"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M1558.57,443.1s170.07,57.95,147.08,192.26c-5.92,34.6-30.27,63.23-63.23,72.63-21.6,6.16-90.73-9.63-145.48-34.07-27.63-12.34-45.27-40.6-44.57-71.53l2.81-123.7,103.38-35.58"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-57"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M1136.42,400.07s-49.43,107.17,35.19,117.15c0,0,1.54.07,4.15-.13,31.23-2.3,54.1-30.44,50.4-61.53-2.41-20.18-7.74-48.44-19.45-65.41,0,0-23.72,19.83-70.28,9.91Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-58"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M1477.11,498.35s4.46,37.81-25.74,56.55c-19.07,11.83-43.42,10.09-61.54-3.16-12.54-9.18-25.3-24.47-29.28-49.61,0,0-6.84-42.51,42.61-61.49,0,0,27.32-9.78,39.52,17.02,1.75,3.48,1.58,7.28-.46,9.63-1.03,1.19-2.32,1.76-3.26,2.05.38.68,2.36,4.21.92,8.12-.98,2.67-3.63,5.39-9.7,7.08,0,0,7.28,12.53-18.31,14.81,0,0-5.14.22-11.69,4.19,0,0,7.5,4.7,7.5,13,0,0,37.5,5.73,69.41-18.21Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-59"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st8",
    cx: 1508.67,
    cy: 428.23,
    rx: 63.59,
    ry: 67.84
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1486.19,434.67c-4.91,14.62,1.34,27.42,8.15,29.35,6.91,1.96,19.24-5.91,22.4-21.43-10.18-2.64-20.36-5.28-30.55-7.92Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M1394.05,493.47l55.94-43.08c2.73-2.1,6.42-2.47,9.51-.94l45.79,22.68c4.89,2.42,6.53,8.6,3.48,13.13l-42.47,63.02c-2.85,4.22-8.62,5.26-12.75,2.28l-59.25-42.62c-4.91-3.53-5.02-10.79-.24-14.48Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-62"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1542.98,554.18c-16.07-16.11-77.21-73.47-87.82-24.39,0,0-27.19-1.33-18.98,25.74,0,0-19.2,2.79-17.17,16.4,1.1,7.43,8,12.44,15.24,11.5l8.38-1.09s23.72,2.54,28.61,17c0,0,.1,1.29.57,3.5,5.57,26.16,33.65,40.56,57.05,28.87,5.75-2.87,10.98-6.93,15.31-12.1,12.41-14.81,14.99-35.84,7.17-53.42-2.01-4.52-4.9-8.55-8.36-12.02Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-63"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M1444.4,400.3c3.67,4.11,9.81,5.28,14.53,2.43,1.4-.85,2.72-2.04,3.73-3.7,4.02-6.58.98-13.34.74-13.84,1.96,2,9.52,9.21,21.27,9.88,17.46.99,28.08-13.37,28.82-14.4.15,1.05,2.13,13.58,13.92,19.36,10.75,5.27,20.89.64,22.15.04-4.46,7.47-4.24,16.7.55,23.41,5.88,8.25,15.73,8.62,16.85,8.64-1.57,1.02-5.88,4.13-8.06,10.02-.12.32-.23.65-.33.97-2.47,7.88,1.82,16.28,9.45,19.43,14.35,5.93,30.25,4.16,40.77-4.49,16.46-13.53,18.62-42.96-.25-62.24,12.48-16.08,11.65-38.43-1.09-52.37-10.88-11.91-28.77-15.83-44.67-9.6-.8-1.99-5.44-13.05-17.51-17.64-10.86-4.13-23.49-1.42-32.58,6.91-8.79-7.42-20.78-9.54-31-5.36-12.21,4.99-19.86,18.14-18.29,32.11-11.41,2.03-20.88,9.79-24.55,20.34-3.7,10.63-1.89,21.77,5.55,30.1Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-64"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M1099.23,1172.09l-52.68-15.42c-11.03-3.23-23.06-1.33-32.21,5.61-6.79,5.16-12.45,13.11-11.78,25.24.45,8.23,3.72,16.04,8.88,22.46,14.67,18.25,60.38,68.93,121.67,77.45,19.5,2.71,38.84-7.27,47.33-25.04.26-.55.52-1.1.76-1.67,6.2-14.2,4.57-27.03,3.65-32.08,4.74-21.99-4.36-44.74-22.89-57.28-18.9-12.8-43.98-12.52-62.73.73"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-66"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st13",
    cx: 1294.57,
    cy: 323.65,
    rx: 52.12,
    ry: 58.59
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-67"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1248.07,297.13s11.59-22.54,26.04-26.64c-2.43.69,8.67,13.53,15.38,14.59,10.51,4.58,19.95,1.75,22.22,1.01.09.68,2.26,15.46,15.15,20.76,7.59,3.12,15.71,1.91,17.95,1.19,5.93,4.68,10.74,8.63,16.67,13.31,24.11-13.88,31.39-44.51,18.18-65.64-11.48-18.36-36.4-26.31-58.43-17.13-15.96-14.08-38.39-17.06-55.48-7.8-21.06,11.41-28.7,41.57-17.68,66.36Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1267.38,327.2s7.66,6.51,24.27,3.94c-1.68,13.08-10.39,20.72-15.65,19.87-5.27-.85-11.15-10.84-8.61-23.81Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-69"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M1187.07,376.84l32.86-41.13c1.82-2.27,4.94-3.23,7.82-2.39l48.92,14.16c4.52,1.31,6.49,6.33,3.95,10.11l-28.11,41.84c-1.71,2.55-5,3.72-8.07,2.87l-53.66-14.87c-4.81-1.33-6.72-6.8-3.7-10.58Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-70"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1329.33,431.65s-69.55-90.49-85.72-21.34c0,0-25.38-.62-15.53,29.17,0,0-41.7,12.04,24.29,39.67,1.28.54,2.08,1.82,2.01,3.21,0,.05,0,.11,0,.16-.66,14.49,8.51,27.66,22.26,32.29,19.6,6.6,41.92,1.19,55.37-14.63,16.34-19.21,15.66-49.13-2.67-68.53Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-71"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1132.67,410.31s-4-20.96.84-42.31c5.34-23.55,25.1-41.41,49.18-43.18,10.34-.76,21.64,1.5,29.99,11.46,2.17,2.59,3.35,5.95,2.92,9.31s-2.49,7.43-8.92,9.47c0,0,1.62,12.04-8.53,13.65,0,0,3.04,8.04-7.67,9.32,0,0,1.93,12.81,21.34,14.73,0,0,8.45,38.35-29.35,50.83,0,0-37.93,8.55-49.79-33.28Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-72"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M1099.23,1172.09s21.21-176.51,121.26-176.51,0,0,0,0c0,0,73.5,1.7,44.46,103.59,0,0-19.91,60.66-80.1,129.48,0,0-59.41-11.16-85.62-56.56Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-73"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M1557.17,1046.91s45.13,78.22-43.82,138.89c0,0-121.77,82.52-264.26-40.19,0,0-139.96-107.94-56.96-145.59,0,0,90.57-29.52,365.04,46.89Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-74"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 1400.2,
    cy: 777.03,
    r: 67.71
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-75"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1339.59,797.46c2.45,13.88,10.9,21.53,16.05,20.51,4.45-.89,8.16-8.59,8.4-18.17-8.15-.78-16.29-1.56-24.44-2.34Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-76"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M1266.19,815.56l64.68-13.88c2.21-.47,4.52-.06,6.42,1.16l14.33,9.17c5.39,3.45,5.25,11.37-.27,14.62l-60.63,35.7c-4.07,2.4-9.32,1.05-11.73-3.01l-18.38-30.98c-2.99-5.04-.16-11.53,5.58-12.76Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-77"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1343.49,739.71c-6.73-11.87-5.93-27.16,1.86-37.71,7.17-9.7,19.04-13.75,30.12-10.24,2.03-19.68,16.19-33.7,30.97-33.44,10.81.19,20.96,7.99,26.39,19.75,13.98-14.36,34.47-16.75,49.61-6.39,17.42,11.91,24.31,38.34,14.5,60.51,24.2,25.33,23.62,63.48,8.55,79.73-10.06,10.85-28.56,14.08-46.06,6.93-15.68-6.41-26.16-22.77-27.72-41.32-.37-4.41-1.22-9.32-2.89-14.5-3.85-11.96-10.21-19.62-13.74-23.31-2.81,5.63-8.4,8.68-13.78,7.64-6.21-1.2-10.96-7.62-10.86-15.17-.47.48-6.07,6.1-13.39,4.14-5.2-1.39-7.94-5.7-8.6-6.81-.75,1.69-3.39,7.07-9.23,10.06-7.56,3.86-14.57.69-15.73.14Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-78"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1414.91,814.57c7.68-1.45,15.67-2.25,22.57-5.9,8.68-4.59,14.49-13.03,20.9-20.46,6.41-7.43,14.71-14.51,24.53-14.58,10.37-.08,19.64,8.43,22.17,18.49,2.54,10.06-.83,20.98-7.15,29.22-6.31,8.23-15.27,14.07-24.63,18.55-17.84,8.53-37.78,12.54-57.53,11.77-13.41-.53-31.17-3.93-24.78-21.95,3.49-9.83,14.62-13.39,23.91-15.14Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-79"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 1441.52,
    cy: 778.47,
    r: 13.89,
    transform: "translate(442.19 2076.68) rotate(-80.78)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-80"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 758.58,
    cy: 890.72,
    r: 39.88
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-81"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 776.13,
    cy: 960.03,
    r: 39.51
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-82"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1111.28,
    cy: 888,
    r: 39.88
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-83"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1093.73,
    cy: 957.32,
    r: 39.51
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-84"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 935.75,
    cy: 997.74,
    r: 43.61
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-85"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M928.43,1012.93c-4.6-5.8-10.76-11.29-18.88-12.94-6.4-1.31-13.11-.06-19.52,1.19-22.01,4.28-44.02,8.56-66.02,12.84-6.18,1.2-10.43,6-9.79,11.24.55,4.46,2.47,8.04,9.39,9.35,11.28,2.14,25.29.62,36.61-.65,5.92-.66,71.53-16.85,68.21-21.04Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-86"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M919.5,1029.5c4.6-5.8,10.76-11.29,18.88-12.94,6.4-1.31,13.11-.06,19.52,1.19,22.01,4.28,44.02,8.56,66.02,12.84,6.18,1.2,10.43,6,9.79,11.24-.55,4.46-2.47,8.04-9.39,9.35-11.28,2.14-25.29.62-36.61-.65-5.92-.66-71.53-16.85-68.21-21.04Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-87"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M859.64,1072.3c4.6-5.8,10.76-11.29,18.88-12.94,6.4-1.31,13.11-.06,19.52,1.19,22.01,4.28,44.02,8.56,66.02,12.84,6.18,1.2,10.43,6,9.79,11.24-.55,4.46-2.47,8.04-9.39,9.35-11.28,2.14-25.29.62-36.61-.65-5.92-.66-71.53-16.85-68.21-21.04Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "log"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M278.63,1297.34s41.94,27.71-5.14,50.26c0,0-39.25-20.79,5.14-50.26Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st109"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M277.57,1300.79s6.74,18.16-3.4,35.18"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M318.62,1226.05l-49.04,66.71c-3.94,5.68,2.22,12.86,8.38,9.77l109.79-47.16-69.12-29.32Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M278.54,1297.25s-15.45-70.49-82.47-35.15c0,0,20.26,67.95,82.47,35.15Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st89"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M278.54,1297.25s-20.28-13.49-50.07-22.71"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1581.48,1278.25s14.07-48.26,49.53-9.95c0,0-8.26,43.64-49.53,9.95Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st92"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1585.08,1278.25s15.35-11.81,34.61-7.16"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M1477.5,1252.79l102.27,35.46c6.59,2.08,11.63-5.93,6.86-10.9l-43.22-44.98-65.92,20.42Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M1639.37,910.07l-483.04-238.14c-45.95-22.65-58.36-83.25-23.96-121.2.62-.68,1.25-1.36,1.88-2.02,21.97-22.92,48.97-29.15,68.5-30.18,13.74-.72,27.41,2.31,39.63,8.65,153.46,79.62,306.92,159.25,460.39,238.87l-63.4,144.02Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st90"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1197.38,706.87c-1.34-16.06,8.77-32.42,23.74-38.39,14.97-5.97,33.57-1.08,43.65,11.49,8.65,10.78,10.88,25.51,18.92,36.75,10.42,14.58,28.97,21.03,46.75,23.28,17.78,2.25,35.95,1.18,53.5,4.77,25.83,5.29,49.36,21.02,64.13,42.86,14.77,21.84,20.6,49.54,15.89,75.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1600.37,810.95c-7.75,14.46-8.47,32.49-1.91,47.53"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M1286.39,1160.45l309.7-113.01c41.08-14.99,87.04,5.47,102.41,46.4.29.77.57,1.54.84,2.33.85,2.42,1.6,4.82,2.25,7.2,11.14,40.35-11.4,82.38-50.87,96.33-111.53,39.41-223.06,78.82-334.58,118.23l-29.75-157.47Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st91"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1716.65,1097.41c-15.93-6.39-34.53-5.75-49.98,1.7-15.46,7.45-27.53,21.61-32.45,38.05-3.98,13.29-3.39,27.46-2.86,41.32.53,13.86.92,28.07-3.42,41.24-4.34,13.18-14.42,25.33-27.98,28.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1653.64,1034.69c-31.38,5.79-51.05,37.3-61.18,67.56-10.13,30.26-15.3,63.37-35.04,88.44-16.4,20.83-40.85,33.41-64.56,45.28-23.71,11.86-48.22,24.22-64.95,44.79-16.73,20.56-23.45,51.83-8.38,73.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1255.7,1174.15c19.93,39.07,61.89,66.4,105.74,67.15,43.86.75,87.42-25.96,105.15-66.08,17.73-40.12,7.54-91.31-25.28-120.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1709.63,1104.6c-23,6.95-42.17,25.47-49.91,48.22-7.73,22.75-3.82,49.12,10.17,68.65"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M586.97,1168.29l-315.16-115.62c-37.44-13.73-79.4,3.68-95.48,40.17-.37.85-.74,1.71-1.1,2.58-16.08,38.94,3.46,83.5,42.65,98.96l325.02,128.25,44.08-154.35Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st97"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M154.17,1151.69c5.36-12.23,16.31-21.87,29.13-25.63s27.24-1.56,38.35,5.85c17.82,11.87,26.11,35.2,45.06,45.15,11.31,5.94,24.63,6.11,37.29,7.85,37.81,5.19,73.22,26.08,96.05,56.66,22.83,30.59,32.78,70.48,26.99,108.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M216,1029.61c-5.62,37.9,10.86,78.27,41.39,101.42s73.85,28.12,108.83,12.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M244.54,1036.97c-2.99,12.31,1.26,25.89,10.05,35.01,8.79,9.12,21.69,13.83,34.35,13.57,12.66-.26,25.01-5.27,34.98-13.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M491.81,1202.12c-12.57,23.35-16.19,51.37-9.99,77.15s22.18,49.09,43.99,64.16"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M198.62,899.72l402.45-168.61c57.38-24.04,73.08-89.74,31.6-132.22h0c-28.05-28.72-74.25-37.54-113.22-21.59l-430.14,176.04,109.31,146.37Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 140.29,
    cy: 829.12,
    rx: 87.78,
    ry: 95.21
  }), /*#__PURE__*/React.createElement("g", {
    className: "st94"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 129.39,
    cy: 829.12,
    r: 12.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M96.36,883.1c4.61,3.75,19.51,14.89,41.58,15.47,25.17.66,42.17-12.88,46.28-16.36"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 580.62,
    cy: 1250.34,
    rx: 79.7,
    ry: 82.05
  }), /*#__PURE__*/React.createElement("g", {
    className: "st93"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M534.16,1274.34c3.33,5.1,12.71,17.97,30.31,25.08,23.06,9.31,43.63,2.03,48.45.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M599.16,1187.84s26.6,1.05,44.03,38.2"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 591.98,
    cy: 1238.08,
    r: 11.37
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1292.6,
    cy: 1243.12,
    r: 81.49
  }), /*#__PURE__*/React.createElement("g", {
    className: "st96"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1243.74,1244.38c.43,3.93,2.61,19.59,16.19,31.86,15.56,14.06,34.26,12.98,37.53,12.74"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1290.63,
    cy: 1239.64,
    r: 10.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1352.35,1214.62c2.66,6.92,7.53,22.44,4.19,41.82-4.21,24.47-18.81,39.5-23.98,44.36"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 1682.5,
    cy: 843.2,
    rx: 77.28,
    ry: 79.93
  }), /*#__PURE__*/React.createElement("g", {
    className: "st95"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1634.68,848.13c.65,6.37,2.87,19.21,12.06,31.89,13.84,19.09,33.73,24.34,39.3,25.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1731.9,804.13c3.46,4.81,11.81,17.77,12.38,36.34.65,21-9.07,35.78-12.38,40.38"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1690.04,
    cy: 839.03,
    r: 7.69
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M1581.42,1278.37s-62.77,35.6-9.19,89.17c0,0,58.92-39.45,9.19-89.17Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1581.42,1278.37s-6.89,23.36-6.89,54.55"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "legs_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M840.89,447.92s-95.12-3.21-80.85,108.44c0,0,8.48,60.85,97.75,110.73,4.92-.19,20.72-1.45,34.55-13.63,18.81-16.57,18.73-39.94,18.66-43.42-15.41-20.15-30.82-40.29-46.23-60.44,0,0,36.43-9.25,64.31-37.13,0,0,16.29,21.73,58.97,35.75,0,0,7.61,42.29-22.79,94.95,0,0,32.9,78.09,85.6,47.66,0,0,105.67-194.76,15.36-225.45-90.32-30.69,0,0,0,0l-50.47-20.47-174.85,3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M864.77,549.6s-5.69-21.06-32.01-15.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M988.05,548.22s9.18-14.38,32.82-6.74"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "left_arm1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M824.47,259.08c41.68-24.18,95.94,5.36,80.18,42.22-.15.35-.3.7-.45,1.04-11.41,25.9-30.97,42.18-41.76,49.95-2.9,7.32-5.41,15.92-7.09,25.6-.11.63-.22,1.28-.32,1.93-8.37,52.6-83.49,54.73-93.93,2.5-1.41-7.05-2.11-15.02-1.95-24.01,0,0-3.59-59.25,65.33-99.23Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "upperbody1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M856.13,250.79l104.65-3.63c3.23.7,44.03,10.23,59.36,49.72,12.28,31.62-.65,59.61-2.96,64.42-8.54,32.41-17.07,64.82-25.61,97.22,0,0-76.34,19.3-150.68-10.61,0,0-26.11-33.12-10.79-88.15-2.5-3.26-20.55-27.67-13.11-60.08,7.61-33.14,35.59-47.19,39.14-48.89Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M826.99,416.48s22.12-6.65,27.61-34.32"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "right_upper_arm1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M982.89,243.78c32.18,8.6,74.02,30.65,93.6,86.78,8.58,24.58-6.44,51.55-32,56.47-.67.13-1.35.25-2.03.35-20.51,3.2-41.51-4.81-53.18-20.33-3.89-4.14-7.95-9.15-11.76-15.05-6.07-9.4-12.54-22.56-14.09-37.6-5.52-3.81-18.14-13.6-24.66-30.39-.08-.22-.17-.43-.25-.65-9-24.03,16.77-46.96,44.37-39.59Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "right_lower_arm_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1078.98,342.49c-3.52-29.35-30.83-45.6-52.1-30.56-.53.37-1.06.76-1.59,1.17-21.45,16.38-24.75,43.95-25.14,47.68-2.84,7.45-5.63,16.67-7.36,27.51-2.7,16.94-3.46,40.26,4.35,65.75.66,1.55,10.53,23.66,31.87,26.15,14.26,1.67,28.26-6.04,36.65-20.15,3.91-11.14,20.17-60.39,13.31-117.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1035.77,367.34c-.2-.16-.39-.32-.59-.48-15.65-12.57-38.9-6.43-46.53,12.14-4.69,11.41-7.56,27.74-.6,47.69"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Right_hand1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M974.6,488.82s-26.82-13.65,3.05-46.59c11.14-12.28,27.05-19.42,43.62-18.79,12.88.49,27.44,5.51,38.66,21.74,13.12,18.98,4.87,45.16-16.92,52.74-.29.1-.58.2-.87.29,0,0-28,45.49-47.02,12.55,0,0-25.62,3-20.52-21.95Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M995.12,510.77s-4.51-16.18,29.81-42.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M974.6,488.82s6.22-23.29,32.09-38.22"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1002.13,446.95s5.14,1.74,8.71,7.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1020.35,464.65s5.45,1.91,9.21,8.42"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "face_1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st88",
    cx: 844.1,
    cy: 219.16,
    r: 11.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M838.18,219.46s1.86-6.9,8.98-5.28"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st88",
    cx: 964.86,
    cy: 199.42,
    r: 13.26
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st88",
    cx: 906.79,
    cy: 219.05,
    rx: 57.34,
    ry: 63.45,
    transform: "translate(-17.84 95.3) rotate(-5.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 872.7,
    cy: 210.81,
    r: 4.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 932.67,
    cy: 197.11,
    r: 4.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M962.44,191.81c.6-.24,3.03-1.1,5.82-.07,3.24,1.2,4.49,4.04,4.7,4.53"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "hair1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M841.19,208.63c6.59,4.24,15.61,2.07,19.07-4.97.14-.29.27-.58.4-.89,3.15-7.62-1.31-14.27-1.63-14.72,5.84-.07,17.46-1.01,29.74-7.95,8.91-5.03,14.71-11.27,18.02-15.47,1.1,1.87,5.73,9.23,15.4,12.44,9.77,3.24,17.95,0,19.93-.84-.07.66-.7,7.43,4.61,12.17.24.21.48.41.72.6,4.94,3.84,12.09,2.9,16.24-1.79,5.15-5.82,6.97-13.76,4.57-20.64-3.68-10.54-15.36-13.13-15.94-13.25,2.58-10.73-2.64-21.67-12.06-26.1-8.27-3.88-18.4-2.1-25.28,4.53-13.7-10.54-32.26-12.13-47.18-4.07-16.07,8.69-24.99,27-22,45.45-7.79,2.64-13.46,9.07-14.34,16.42-.86,7.23,3,14.72,9.74,19.06Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M864.98,147.87c1.03-2.35,2.32-4.61,4.08-6.47s4.03-3.31,6.54-3.81c.52-.1,1.15-.13,1.47.29.28.36.19.9-.07,1.28s-.65.64-.99.95c-1.08.96-1.73,2.39-1.75,3.84,2.17-1.75,4.46-3.55,7.2-4.05.94-.17,2.15-.02,2.47.88.23.66-.16,1.36-.59,1.9-1.21,1.51-2.83,2.61-4.28,3.89s-2.78,2.87-3.07,4.78c1.64-1.33,3.47-2.45,5.4-3.31.76-.34,1.81-.56,2.27.13.45.67-.11,1.54-.66,2.12-3.18,3.39-7.12,6.29-8.99,10.54-.23.52-.43,1.06-.77,1.51s-.87.81-1.43.78c-.59-.03-1.11-.48-1.35-1.02s-.25-1.16-.18-1.75c.28-2.34,1.7-4.39,2.23-6.68.06-.28.11-.59-.04-.84-.21-.34-.72-.38-1.07-.19s-.58.54-.8.87c-.84,1.29-1.71,2.56-2.61,3.81-.51.7-1.25,1.48-2.08,1.25-.57-.16-.92-.77-.96-1.36s.16-1.17.36-1.73c.36-1.02.72-2.04,1.08-3.06.09-.26.18-.55.06-.8-.15-.32-.61-.4-.94-.25s-.56.45-.77.74c-1.06,1.44-2.12,2.88-3.18,4.31-.26.35-.52.7-.89.92s-.88.25-1.21-.03c-.49-.43-.28-1.22-.03-1.82,1.49-3.55,3.16-7.05,5.46-10.13s5.29-5.74,8.87-7.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M865.41,148.12c1.75-3.86,4.17-7.61,8.21-9.36.82-.35,3.49-1.76,2.58.55-.12.31-.91.82-1.11,1.07-.86,1.05-1.2,2.24-1.31,3.57-.04.48.55.6.85.35,1.64-1.32,3.38-2.74,5.39-3.48.66-.26,1.34-.42,2.05-.49l.4,2.61c-.19.66-1.63,1.51-2.15,1.94-2.14,1.77-4.17,3.51-4.79,6.33-.11.52.45.79.84.49,1.01-.79,2.06-1.52,3.17-2.16.41-.23,2.12-1.4,2.62-1.24,2.24.73-2.25,4.39-2.81,4.93-1.29,1.26-2.58,2.54-3.69,3.97-.49.64-.96,1.3-1.36,2-.23.39-.65,1.92-1.04,2.15-2.02-.32-2.73-1.12-2.14-2.39.16-.5.34-.99.54-1.47.29-.73.63-1.45.9-2.19.24-.68.87-1.97.37-2.72-1.43-2.13-3.53,1.9-4.01,2.61-.26.38-.52.76-.79,1.14-.76,1.8-1.53,1.57-2.31-.7-.06-.77.74-1.92.95-2.68.16-.59.46-1.18.02-1.7-1.53-1.84-3.77,2.43-4.3,3.14-.59.8-2.37,4.2-2.25.55.03-.82.93-2.09,1.29-2.83.9-1.87,1.89-3.69,3.06-5.4,2.4-3.52,5.51-6.39,9.46-8.06.59-.25.08-1.11-.5-.86-7.1,3-12.2,10.43-14.56,17.58-.69,2.08.77,3.44,2.57,1.93,1.31-1.1,1.89-3.03,3.13-4.2,2.21-2.08.77.57.45,1.5-.29.84-.75,1.77-.63,2.69.31,2.59,2.72,1.84,3.89.39.51-.63.95-1.32,1.4-1.99.33-.49,1.88-3.17,2.17-1.78.14.68-.7,1.97-.95,2.58-.44,1.09-.92,2.17-1.11,3.34-.28,1.7.43,4.5,2.74,3.62,1.35-.51,1.74-2.29,2.35-3.41,1.09-2,2.64-3.69,4.24-5.29,1.18-1.18,6.46-4.77,4.82-6.95-1.77-2.34-7.02,2.11-8.38,3.18l.84.49c.75-3.4,3.77-5,6.1-7.24.97-.93,2.55-2.48,1.65-3.94-2.11-3.44-8.56,1.89-10.31,3.29l.85.35c.18-2.19,1.52-2.82,2.59-4.43.32-.48.44-.91.28-1.45-.39-1.32-1.84-1.06-2.92-.78-5,1.32-8.16,5.88-10.18,10.34-.26.58.6,1.09.86.5h0Z"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "eyebrows1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 880.55,
    cy: 189.66,
    rx: 5.95,
    ry: 2.91,
    transform: "translate(23.14 465.68) rotate(-30)"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "eyebrows11",
    "data-name": "eyebrows1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 914.3,
    cy: 181.02,
    rx: 5.68,
    ry: 2.74
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "eye1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M880.55,201.31c-.45-2.52,1.1-4.93,3.42-5.52,2.07-.53,4.33.49,5.37,2.51"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "eye11",
    "data-name": "eye1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M911.61,192.11c-.03-2.44,1.73-4.52,4.04-4.87,2.1-.32,4.22.88,5.1,2.91"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "nose1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M898.66,192.83s-2.54,13.73,8.51,11.85"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "mouth1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M884.9,216.1c2.18,17.93,17.27,27.7,26.76,25.36,9.31-2.3,17.97-17.42,12.3-34.04l-39.06,8.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M894.61,240.07s9.74-18.46,30.95-8.94l-3.66,10.67-15.11,3.1-12.18-4.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M888.19,212.6l.06.23c1.51,5.56,6.97,9.09,12.66,8.17,2.02-.33,4.13-.74,6.31-1.26,1.44-.34,2.83-.71,4.16-1.1,5.42-1.57,8.79-6.96,7.92-12.53v-.09s-31.11,6.58-31.11,6.58Z"
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "smores1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M932.04,250.66c.76,1.55.51,3.38.18,5.07-.88,4.48-2.27,8.84-3.65,13.19-2.05,6.46-4.1,12.92-6.16,19.37-.94,2.97-2.18,6.28-5.05,7.49-1.8.76-4.23.29-5.14-1.44-.8-1.52-.22-3.37.37-4.98,4.67-12.75,9.25-25.55,14.02-38.27.42-1.12.72-2.21,2.04-2.39.92-.12,3.39.73,3.39,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M919.5,288.9c.82-1.32,1.64-2.65,2.45-3.97.83-1.35,1.67-2.7,2.5-4.05.39-.63.77-1.48.3-2.04-.52-.63-1.69-.35-2.21-.99-.49-.61-.02-1.49.45-2.11,1.71-2.29,3.43-4.57,5.14-6.86.75-1,1.54-2.24,1.11-3.42-.29-.78-1.08-1.35-1.17-2.17-.13-1.14,1.1-1.93,1.55-2.98.61-1.44-.33-3.03-.49-4.59-.3-2.89,2.09-5.51,1.94-8.41-.04-.84-.65-1.88-1.46-1.63-.57.17-.77.86-.88,1.45-2.54,13.17-7.47,25.73-12.39,38.21-.79,2.01-3.17,5.55-1.4,7.62s3.77-2.79,4.55-4.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M919.6,288.08c.61-1.26.77-2.68.93-4.07.22-1.97.44-3.94.67-5.92.16-1.39.25-2.98-.73-3.98-.91-.94-2.5-.95-3.64-.32s-1.93,1.77-2.53,2.93c-1.57,3.06-2.62,7.64-1.58,11.06,1.06,3.47,5.35,3.46,6.88.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M923.97,271.13c.75-1.83,1.5-3.67,2.26-5.5.57-1.4,1.13-3.05.35-4.35-.51-.86-1.54-1.33-2.53-1.36s-1.98.31-2.86.79c-3.39,1.83-6.07,6.49-5.47,10.42.25,1.64,1.38,2.71,2.94,3.23,2.74.9,4.34-.86,5.31-3.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M920.57,258.52c.45,1.45,1.82,2.73,3.32,2.54,1.22-.15,2.14-1.19,2.7-2.28.66-1.28.97-2.79.61-4.18s-1.46-2.64-2.87-2.92c-3.8-.76-4.56,4.3-3.77,6.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M923.93,253.08c.38.51.86.99,1.47,1.28s1.39.34,1.99.02c.63-.34.92-1.01,1.17-1.64.79-2,1.59-3.99,2.38-5.99.48-1.21.95-2.57.32-3.72-.77-1.41-2.99-1.79-4.58-1.13-4.29,1.78-5.16,7.97-2.75,11.19Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M862.83,271.91l20.62-37.64c1.13-2.07,3.38-3.27,5.73-3.05l32.52,2.93c3.67.33,6.15,3.9,5.19,7.45l-12.28,45.26c-.85,3.13-4.06,5-7.2,4.19l-40.86-10.55c-3.74-.97-5.57-5.19-3.72-8.58Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 888.48,
    cy: 237.26,
    r: 1.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 900.31,
    cy: 238.12,
    r: 1.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 911.01,
    cy: 239.38,
    r: 1.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 921.83,
    cy: 240.82,
    r: 1.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 919.22,
    cy: 250.29,
    r: 1.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 908.72,
    cy: 248.71,
    r: 1.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 898.41,
    cy: 247.16,
    r: 1.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 884.9,
    cy: 245.61,
    r: 1.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 881.2,
    cy: 253.71,
    r: 1.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 895.53,
    cy: 256.35,
    r: 1.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 906.79,
    cy: 258.69,
    r: 1.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 916.85,
    cy: 260.36,
    r: 1.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 913.87,
    cy: 270.68,
    r: 1.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 911.92,
    cy: 279.05,
    r: 1.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 904.34,
    cy: 267.7,
    r: 1.55
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "left_fingers1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M870.32,338.18c-2.32,25.71-25.83,42.43-46.62,38.23-16.95-3.42-30.58-20.44-30.39-40.82.06-6.77,1.04-29.59,18.16-50.1,8.29-9.94,20.37-19.14,37.93-25.14,28.83-6.92,51.86-2.17,57.24,9.83,1.09,2.43,1.97,6.32.38,12.25.71.33,7.99,3.94,9.41,12.23,1.19,6.92-2.57,12.04-3.23,12.9,1.15.78,5.63,4.02,5.99,9.08.29,4.08-2.25,7.17-3.53,8.73-9.07,11.04-42.01,12.66-45.35,12.81Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M911.56,306.88s-25.07-12.28-56.84,10.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M905.85,281.89s-32.81-16.48-65.8,7.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M839.19,281.49s-3.17,8.41,4.7,13.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M851.8,310.08s-.71,7.79,8.68,13.21"
  }))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "left_thigh2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M542.18,458.87c-62.68-14.48-114.37,51.48-83.92,108.14.43.79.87,1.58,1.32,2.37,22.79,39.66,71.56,58.17,115.97,43.34,29.62,18.95,66.82,15.75,89.05-5.85.45-.44.89-.88,1.32-1.33,22.48-23.23,20.91-60.67-2.79-82.66-12.58-11.68-28.24-23.96-47.32-35.03-25.7-14.9-51.03-23.77-73.62-28.99Z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "right_shoe2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M726.48,736.75s-13.13,69.77,55.54,69.77c0,0,48.9.55,75.29-28.2,8.28-9.02,10.3-22.35,4.26-32.99-4.54-8-13.92-15.27-32.86-16.1-5.41-.24-10.75-1.53-15.47-4.17-6.05-3.38-12.4-9.43-13.57-20.12-2.34-21.37,0,0,0,0-12.35-12.03-30.66-15.64-46.46-9.19-16.43,6.71-27.11,23.07-26.73,41"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M749.37,781.67s36.88,14.29,89.63,2.11"
  }))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "right_leg2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M695.55,496.14c14.82-4.87,33.67-3.54,53.09,17.55,10.12,10.99,17.36,24.3,21.48,38.65,7.78,27.12,23.52,87.67,29.55,152.59,0,0-21.07,39.17-73.19,31.82l-53.12-140.28s-11.93-22.49-12.82-48.85c-.77-23.01,13.13-44.3,35-51.48Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st62"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M740.93,722.13s27.58-1.56,54.35-28.32"
  }))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "left_shoe2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M574.13,727.69s-16.91,29.96-16.14,62.63c.23,9.83,5.62,18.83,14.12,23.78,25.82,15.03,86.64,44.55,121.73,13.18,10.89-9.74,12.47-26.41,2.99-37.52-4-4.68-10.16-9.05-19.53-12.25l-22.69-11.21s-9.87-7.63-13.73-21.69c-3.86-14.06,0,0,0,0-2.6-14.42-13.28-26.09-27.34-29.88-14.45-3.9-29.97,1.21-39.39,12.97"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st63"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M694.21,813.52s-45.12,32.05-106.54-7"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M656.03,759.13s-.15-.02-.42-.05c-17.85-1.78-24.71,22.69-8.59,30.58,13.63,6.67,32.43,10.55,48.36-5.39l-39.34-25.14Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st64"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 648.03,
    cy: 778.13,
    rx: 1.99,
    ry: 2.9,
    transform: "translate(-322.18 1068.19) rotate(-66.86)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 658.19,
    cy: 783.68,
    rx: 1.99,
    ry: 2.9,
    transform: "translate(-321.11 1080.9) rotate(-66.86)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 668.35,
    cy: 788.76,
    rx: 1.99,
    ry: 2.9,
    transform: "translate(-319.61 1093.33) rotate(-66.86)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 656.55,
    cy: 767.92,
    rx: 1.99,
    ry: 2.9,
    transform: "translate(-307.61 1069.83) rotate(-66.86)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 666,
    cy: 772.72,
    rx: 1.99,
    ry: 2.9,
    transform: "translate(-306.29 1081.44) rotate(-66.86)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 676.03,
    cy: 777.3,
    rx: 1.99,
    ry: 2.9,
    transform: "translate(-304.41 1093.43) rotate(-66.86)"
  }))))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "left_leg2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M593.74,547.83s-35.27,40.16-19.61,179.86c3.04,3.77,12.99,15.14,30.54,19.59,17.55,4.45,31.72-.81,36.19-2.68,11.5-12.33,30.09-47.73,47.43-96.63,17.86-50.4,24.03-104.95-22.77-121.59-23.93,7.15-47.85,14.3-71.78,21.45"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st65"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M587.67,721.2s25.17,18.86,52.5,7.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M572.93,613.27s14-2.32,23.48-18.73"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M688.98,545.57s25.52,15.06,4.49,86.46"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "light_hand2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M665.52,330.91s-24.45,37.08-14.09,106.67c3.67,24.66,25.29,43.08,50.19,42.03.61-.03,1.22-.06,1.84-.11,7.19-.55,13.45-2.51,18.77-5.1,12.61-6.14,22.17-17.15,27.07-30.29,2.77-7.43,5.17-16.01,6.41-25.65,2.81-21.9.82-52.13-17.9-86.3-2.26-4.13-5.07-7.97-8.53-11.17-8.9-8.23-20.9-12.36-32.91-10.91-19.93,2.4-29.79,18.96-30.86,20.83Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st66"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M740.04,347.78s-9.72,23.3-34.48,20.24"
  }))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "body2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M543.94,307.2c-23.64,1.22-42.71,19.2-44.91,41.31-2.38,23.9,15.57,46.54,41,50.06,5.21,39.47,10.43,78.93,15.64,118.4,0,0,60.53,4.23,95.05-45.32,0,0,17.26-39.13,13.07-108.84,1.16-1.15,6.09-16.16,3.32-29.83-2.87-14.2-19.66-25.59-39.47-22.84-27.9-.98-55.81-1.97-83.71-2.95Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st67"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M610.1,372.54c-3.31.3-6.13,3.35-6.18,6.67s2.7,6.45,6,6.83c-4.03-.8-8.39,2.37-8.88,6.44s2.98,8.19,7.08,8.39,7.95-3.57,7.84-7.68c-1.04,3.34.54,7.3,3.59,9s7.25.99,9.55-1.64,2.46-6.89.37-9.68c2.01,2.6,6.49,2.48,8.59-.05s1.59-6.68-.86-8.87-6.38-2.32-9.17-.59c2.67-1.97,3.48-6.05,1.78-8.9s-5.68-4.06-8.68-2.64c-2.96,1.4-3.87,4.49-3.84,7.43-1.37-2.77-3.86-5.02-7.17-4.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M624.63,384.14c1.19,2.26.31,5.39-1.89,6.69s-5.36.6-6.79-1.52c-4.01-5.96,5.36-11.5,8.68-5.17Z"
  }))))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "left_hand2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M630.29,542.95c-18.48,11.55-41.74,7.11-52.86-8-4.65-6.31-6.9-14.12-6.72-22.14.25-11.23,5.67-21.65,14.12-29.05,3.23-2.83,7.04-5.53,11.57-7.71,13.77-6.64,35.39-10.28,66.77,1.7,0,0,55.3,30.3,25.18,54.75,0,0,2.04,18.29-14.99,15.73,0,0-1.2,17.27-14,15.01-4.04-.71-7.5-3.29-9.64-6.79-4.17-6.8-13.28-19.63-19.43-13.49Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st60"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M673.36,548.22s-2.79-24.19-27.64-27.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M688.34,532.49s-3.09-23.55-26.72-29.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M642.44,526.56s.66-8.32,7.86-11.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M658.87,508.69s0-7.22,7.26-8.02"
  }))))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "left_upper_hand2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M540.75,304.34c-34.41-5.01-65.93,22.07-79.24,47.73-18.86,36.36-9.22,85.36,24.76,121.71,12.62,16.95,34.31,24.49,54.35,18.97.59-.16,1.17-.33,1.75-.52,25.92-8.17,37.36-38.18,24.95-62.36-1.37-2.66-2.67-5.59-3.81-8.79-3.66-10.23-4.34-19.25-4.31-25.16,21.35-10.66,33.57-31.69,30.8-51.3-3.72-26.23-32.56-37.86-49.23-40.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M572.4,343.34s16.36,42.43-25.33,71.39c0,0,11.22,2.67,28.47,19.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M665.13,376.86s6.13,34.03-13.18,94.8"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "left_lower_hand2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M574.71,529.65c1.86.11,24.47,1.03,38.77-17.68.34-.44.67-.89.98-1.33,11.7-16.57,9.53-39.1-4.22-54.02-4.93-5.35-11.64-10.96-20.54-15.23-10.02-4.8-22.74-7.8-38.59-6.39-15.24-.43-29.48,7.03-37.15,19.62-9.46,15.54-4.57,31.72-3.77,34.2,1.59,4.59,8.62,23.13,28.59,33.95,15.54,8.42,30.33,7.51,35.93,6.88Z"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "face2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st8",
    cx: 580.84,
    cy: 266.63,
    rx: 55.03,
    ry: 65.21,
    transform: "translate(-24.93 470.39) rotate(-43.25)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st101",
    cx: 586.5,
    cy: 274.41,
    r: 4.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st101",
    cx: 627.17,
    cy: 253.83,
    r: 4.18
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "mouth2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M603.46,280.37c6.36,13.65,17.64,19.82,23,17.48,5.47-2.39,8.75-15.4,2.16-29.81-8.39,4.11-16.78,8.22-25.16,12.33Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st58"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M613.85,298.48s1.66-17.75,22.15-14.46l-2.9,10.16-4.41,8.3-10.76,3.31-4.08-7.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M605.57,277.2l.34.5c2.52,3.64,7.31,4.91,11.3,2.99l2.99-1.44c4.47-2.15,6.35-7.52,4.2-11.99h0s-18.83,9.95-18.83,9.95Z"
  }))))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "smores_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M615.38,321.65c1.11,2.12,3.4,3.31,5.55,4.37,17.34,8.57,34.67,17.13,52.01,25.7,1.11.55,2.45,1.09,3.52.47,1.21-.71,1.22-2.58.39-3.71s-2.2-1.7-3.51-2.23c-17.58-7.15-34.52-15.9-50.54-26.09-1.3-.83-4.37-3.79-5.94-3.68-2.23.16-2.29,3.64-1.49,5.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M620.9,330.4c2.45-.52,3.58-4.3,6.06-4,2,.24,2.56,2.92,2.25,4.91s-.87,4.33.52,5.8c1.34,1.43,3.78,1.05,5.38-.09s2.7-2.83,4.18-4.12,3.68-2.13,5.38-1.16c1.76,1.01,2.08,3.36,2.34,5.37s.96,4.39,2.91,4.93c1.64.46,3.45-.65,5.06-.08,1.41.5,2.1,2.1,2.27,3.59s0,3.01.4,4.45,1.69,2.81,3.17,2.6c2.89-.41,2.88-5.75,5.79-6.03,1.19-.11,2.32.77,3.5.59,1.53-.24,2.23-2.23,1.71-3.68s-1.83-2.46-3.09-3.37c-9.27-6.7-19.02-12.73-29.16-18.02-3.99-2.09-14.21-8.17-18.56-4.69-2.6,2.08-6.84,14.45-.09,13.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M618.47,310.78c-.76,1.52-.84,3.44.06,4.89.88,1.43,2.5,2.18,4.03,2.87,2.47,1.1,4.94,2.2,7.41,3.31.97.43,1.97.87,3.03.85,2.33-.06,4.09-2.52,4.02-4.85s-1.53-4.42-3.28-5.96c-3.65-3.22-12.35-6.92-15.27-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M636.05,325.18c.55,1.34,1.7,2.31,2.82,3.23,2.3,1.89,4.59,3.78,6.89,5.67,1.06.87,2.23,1.79,3.6,1.82,1.44.04,2.76-.97,3.42-2.25s.72-2.79.54-4.22c-.44-3.52-2.4-6.83-5.27-8.91-2.17-1.57-6.29-3.33-9.05-2.44s-3.96,4.64-2.95,7.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M655.64,339.07c.45,3.07,2.88,5.83,5.93,6.37s6.43-1.45,7.17-4.46c.63-2.56-.63-5.32-2.66-7-1.48-1.22-5.38-3.31-7.41-2.66-2.53.81-3.35,5.55-3.03,7.75Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M620.56,296.03l22.67-16.83c2.26-1.68,5.15-2.24,7.87-1.55l44.59,11.42c6.15,1.57,8.96,8.7,5.55,14.05l-20.83,32.66c-2.7,4.23-8.25,5.57-12.58,3.03l-46.44-27.24c-5.76-3.38-6.21-11.55-.84-15.53Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st61"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 627.94,
    cy: 302.1,
    r: 2.64
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 638.83,
    cy: 291.89,
    r: 2.64
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 651.95,
    cy: 298.95,
    r: 2.64
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 679.08,
    cy: 313.67,
    r: 2.64
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 661.02,
    cy: 289.14,
    r: 2.64
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 665.31,
    cy: 306.08,
    r: 2.64
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 649.31,
    cy: 283.19,
    r: 2.64
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 642.15,
    cy: 309.8,
    r: 2.64
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 656.36,
    cy: 317.1,
    r: 2.64
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 670.59,
    cy: 324.68,
    r: 2.64
  }))))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "hand2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M664.01,299.8s-11.77-18.67,11.41-27.35c12.84-4.8,27.23-3.99,39.36,2.4,6.55,3.45,13.37,8.84,18.45,17.23,11.11,18.35,5.51,37.17,4.6,40.08-4.47,14.89-17.15,25.82-32.26,27.82-11.73,1.55-23.49-2.46-32.01-10.59-5.78-5.52-6.67-14.68-1.49-20.77.22-.25.44-.5.67-.74,5.72-5.92,13.66-4.7,14.35-4.58-1.02-.24-2.71-.77-4.21-2.18-1.65-1.54-3.16-4.15-3.16-8.53,0,0-14.62,2.35-15.71-12.77Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M665.2,298.25s14.11-21.53,42.97-6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M680.63,310.76s8.07-15.25,28.31-3.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M708.16,287.05s2.6,3.74.02,10.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M709.61,302.21s1.16,4.99-2.37,10.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M687.09,323.29s9.43,3.22,13.07,5.33c0,0,8.35,3.96,5.15,11.94"
  }))))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "left_eyebrow2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st101",
    cx: 586.08,
    cy: 250.64,
    rx: 6.64,
    ry: 4.06,
    transform: "translate(-32.88 402.95) rotate(-36.98)"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "right_eyebrow2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st101",
    cx: 610.55,
    cy: 234.78,
    rx: 5.86,
    ry: 3.35,
    transform: "translate(-36.46 138.5) rotate(-12.57)"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "left_eye2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M593.78,262.39c-1.8-1.93-1.55-4.94.3-6.43,1.63-1.31,4.19-1.19,5.83.44"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "right_eye_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M614.14,247.79c-1.28-2.07-.59-4.75,1.35-5.89,1.75-1.03,4.13-.57,5.46,1.15"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "nose2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M606.33,250.14s10.78,5.7,8.17,16.33"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "pony_tail2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M539.21,203.15c5.65-3.13,7.65-11.01,5.56-17.23-2.09-6.22-7.4-10.83-13.2-13.67-9.47-4.65-20.78-5.23-30.67-1.58-9.88,3.65-18.22,11.48-22.61,21.25-2.4,5.34-3.65,11.19-6.41,16.35-10.79,20.15-23.93,2.42-35.13-5.81-8.21-6.03-19.49-7.64-29.06-4.14s-17.16,12-19.55,21.9c-1.55,6.44-1.14,13.59-4.75,19.14-8.48,13-28.95,6.88-41.7,11.6-14.74,5.45-26.78,17.86-31.92,32.7-6.62,19.16-1.9,41.75,11.25,56.98,13.16,15.23,34.07,22.79,53.78,20.17,19.71-2.62,37.77-15.1,48.17-32.42,6.23-10.38,10.26-22.82,19.92-29.95,13.39-9.89,34.06-6.74,45.13-19.26,6.51-7.37,7.65-18.26,6.43-28.11s-4.41-19.39-5.34-29.27.88-20.8,8.01-27.55c6.14-5.81,16.64-6.57,23.16-.99,5.51,4.72,9.8,14.97,18.91,9.92Z"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "hair2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M526.39,281.26s2.68-6.83,10.43-10.67c4.47-2.21,9.57-2.6,14.49-1.77,5.8.97,11.7-1.33,15.05-5.98,4.03-5.6,3.6-13.54-1.05-19-1.87-2.2-2.6-5.23-1.81-8.01.57-2.03,1.8-3.77,3.51-4.87,3.77-2.41,8.14-.52,8.48-.36.35.2,5.14,2.87,10.01.37,1.61-.82,2.74-1.96,3.52-3.04.96-1.33,1.3-2.97,1.3-4.61,0-1.87,1.13-3.6,2.85-4.26,1.74-.67,3.78-.12,5.04,1.34.72.84,1.64,1.53,2.69,1.88,1.96.66,4,.31,5.29-.88,1.7-1.57,1.49-4.03,1.45-4.37-19.63-17.27-49.02-17.67-68.73-1.26-18.97,15.79-24.35,43.3-12.54,65.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M525.41,235.26c-7.41-10.18-5.86-24.31,3.15-32.36,9.57-8.55,24.9-7.88,33.98,1.98-4.27.67-14.24,2.82-23.62,10.89-8.34,7.18-12.02,15.44-13.52,19.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M524.21,219.46s6.43-17.69,25.67-17.69"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "ear2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st8",
    cx: 531.71,
    cy: 284.33,
    rx: 13.86,
    ry: 11.98
  }), /*#__PURE__*/React.createElement("g", {
    className: "st54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M525.41,285.41s2.01-8.57,11.82-5.94"
  }))))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "left_thigh3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M307.37,630.19s72.79-37.02,139.1-35.62c48.95,1.04,89.97,37.46,97.85,85.78l59.13,245.49-121.77-1.51-52.1-203.13-129.87,18.64,7.65-109.65Z"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "rightthigh3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M135.62,643.92c-32.86,25.93-47.43,67.06-36.83,101.7,14.13,46.16,71.68,76.65,128.92,57.81,6.86,37.42,43.86,60.09,76.48,51.68,33.86-8.72,55.36-48.94,40.68-85.66-4.93-23.31-9.87-46.61-14.8-69.92-4.9-23.14-9.8-46.29-14.7-69.43-59.92,4.6-119.83,9.21-179.75,13.81Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140.1,726.35s24.24,13.73,40.26-14.03"
  }))))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "right_lower_leg3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M230.27,818.81c-5.39-32.39,15.21-63.93,47.32-70.81.68-.15,1.37-.28,2.06-.4,26.93-4.84,54.22,8.38,67.28,32.68,4.68,17.19,9.35,34.46,13.94,51.82,7.67,29.01,18.3,69.83,31.35,121.52,8.64,34.24-11.07,69.74-45.05,79.34-.7.2-1.42.39-2.14.57-.73.18-1.46.35-2.19.51-37.91,8.26-75.25-16.46-83.66-54.33-5.11-23.01-12.9-64.71-28.9-160.9Z"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "left_hand3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M365.24,423.3c-18.02,11.94-28.86,33.13-30.61,54.68s4.94,43.25,16.26,61.67c11.31,18.42,27.05,33.79,44.12,47.06,16.4,12.75,34.7,23.94,55.12,27.75,22.7,4.24,47.13-1.39,65.48-15.4s30.25-36.26,31.38-59.32c1.51-30.89-15.68-60.34-38.83-80.84-35.55-31.48-97.09-65.96-142.9-35.6Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M467.7,537.4s28.01,26.19,59.21,8.17"
  }))))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "body3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M256.77,407.4s-70.59,19.97-114.36,74.17c-21.39,26.48-14.95,66.26,14.29,83.68,3,1.79,6.18,3.32,9.53,4.56,24.86,9.21,53.57.49,69.71-21.59,1.44,4.86,2.82,10.26,3.62,16.2,1.4,10.4,2,25.4-1.25,43.8,0,0,32.6,15.89,58.14,41.44,0,0,47.12,1.19,69.43-37.45,0,0,10.31-24.97,10.31-52.94,4.29-.65,30.72-5.1,45.87-28.98,7.24-11.41,10.38-24.85,9.48-38.37-1.13-16.94-8.91-32.75-21.18-44.49-7.49-7.17-16.55-14.45-27.39-21-52.1-31.42-107.46-22.82-126.21-19.01Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st50"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M291.18,562.93s27.27,3.55,69.31-12.26c0,0,7.52,26.51-7.99,61.31,0,0-27.81,21-57.63,13.2s0,0,0,0c0,0-9.09-32.82-3.69-62.25Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 353.6,
    cy: 563.43,
    r: 3.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 297.71,
    cy: 572.04,
    r: 3.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 299.72,
    cy: 618.86,
    r: 3.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 347.19,
    cy: 607.74,
    r: 3.4
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M376.2,559.25s2.15-14.66,2.15-31.4"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "right_upper_arm3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M244.18,575.47c0,54.5-31.31,103.95-70,103.95s-70.23-39.99-70.23-94.5,31.43-116.71,70.11-116.71,70.11,52.76,70.11,107.26Z"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "lower_hand"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M111.85,636.16c-13.69-38.96,14.39-80.62,55.68-81.48.69-.01,1.37-.02,2.06-.01,31.36.29,59.64,22.04,68.72,53.55,7.52.16,20.14,1.45,33.86,8.14,3.04,1.48,5.85,3.09,8.46,4.78,24.93,16.17,32.23,49.83,15.11,74.12-.39.55-.79,1.11-1.21,1.66-21.54,28.55-57.68,26.49-60.41,26.29-11.62-.09-48.68-1.84-82.24-29.23-21.7-17.72-33.56-39.33-40.05-57.81Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st51"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M238.32,608.21s-24.67-5.92-34.61,20.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M280.79,643.92s-47.4,1.23-56.56,54.94"
  }))))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "right_hand3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M280.79,757.43c-3.98-.65-22.33-4.08-32.69-20.01-11.62-17.88-8.48-44.25,9.16-63.27,5.42-5.42,21.25-19.82,46.47-23.96,30.2-4.95,53.03,8.25,58.89,11.89,30.5,14.04,44.11,36.48,39.78,50.33-1.73,5.52-7.2,10.41-18.31,13.94,0,0,7.26,38.04-31.35,27.67,0,0,6.33,42.67-47.66,13.66,0,0-4.69-13.91-24.28-10.25Z"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "face_3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st13",
    cx: 330.71,
    cy: 398.58,
    rx: 63.31,
    ry: 71.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 320.06,
    cy: 399.25,
    r: 5.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 375.98,
    cy: 388.33,
    r: 5.09
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "left_eyebrow3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 321.96,
    cy: 371.93,
    rx: 8.3,
    ry: 4.43,
    transform: "translate(-99.21 117.76) rotate(-18.01)"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "right_eyebrow3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 366.74,
    cy: 363.79,
    rx: 8.03,
    ry: 4.16
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "hair3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M268.62,409.66c-.48-2.05-1.46-7.5,1.01-13.61.02-.04.04-.09.05-.13,1.99-4.83,7.03-7.62,12.23-7.11,3.85.38,8.08-.02,11.23-2.38,5.05-3.78,7.35-10.52,5.87-17.02-.82-3.6-.04-7.39,2.4-10.17,1.41-1.61,3.3-3.21,5.78-4.42,1.93-.94,3.82-1.45,5.53-1.69,3.52-.5,7.02.67,9.78,2.91,7.14,5.82,16.29,6.7,22.35,2.71,4.2-2.76,5.94-7.22,6.65-10.03.6-2.35,1.89-4.5,3.85-5.94,1.1-.8,2.46-1.53,4.11-1.91,4.84-1.14,10.15,1.06,13.38,5.59,7.73-.63,13.6-6.8,13.86-13.65.3-7.92-6.94-15.29-16.02-14.78.22-1.04,2.57-13.12-6.13-22.2-6.46-6.74-16.43-9.15-25.58-6.19-9.55-13.84-26.96-20.09-43.1-15.5-16.25,4.63-27.78,19.28-28.47,36.21-10.65-1.94-21.46,1.94-27.98,10.15-7.59,9.55-8.11,23.37-1.1,34.09-9.14,7.87-13.33,20.08-10.89,31.82,2.52,12.16,11.76,21.92,23.83,25.2,1.78,4.97,6.92,7.54,11.22,6.23,3.35-1.02,5.84-4.3,6.15-8.2Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st52"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M266.65,327.84c-4.18,3.02-7.35,7.41-8.89,12.34-.23.73-.39,1.62.13,2.17.87.94,2.36-.08,3.28-.97,2.16-2.08,4.83-3.61,7.71-4.42.69-.19,1.51-.32,2.04.16.85.78.11,2.16-.59,3.07-2.3,3.04-3.89,6.6-4.62,10.34-.26,1.33-.17,3.11,1.11,3.56,1.25.44,2.42-.8,3.17-1.9,5.3-7.78,10.61-15.56,15.91-23.34.6-.88,1.23-1.9,1.01-2.95-.31-1.46-2.19-2.1-3.61-1.66s-2.5,1.59-3.56,2.64-2.28,2.11-3.76,2.25c-1.29-.77-.92-2.7-.37-4.1s.93-3.33-.35-4.11c-1.01-.62-2.31.01-3.29.68-6,4.07-10.88,9.78-13.98,16.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M265.94,327.13c-2.96,2.29-5.44,4.97-7.23,8.27-.9,1.66-3.11,5.26-1.77,7.21.95,1.39,2.06,1,3.45.58,1.59-.47,9.2-8.44,9.1-3.51-.03,1.24-2.67,4.32-3.22,5.66-.64,1.53-1.29,3.26-1.5,4.92-.16,1.25-.36,2.95.61,3.97,4,4.2,9.41-7.31,10.79-9.33,2.83-4.15,5.66-8.3,8.49-12.45,1.27-1.86,3.94-4.51,3.14-7.07-.46-1.45-1.92-2.2-3.35-2.29-2.4-.15-6.33,4.91-7.85,2.18-.77-1.38,1.54-3.51-.6-5.09-1.5-1.1-3.11-.25-4.5.52-6.3,3.5-11.22,10.41-14.34,16.7-.57,1.15,1.15,2.16,1.73,1.01,2.73-5.51,6.42-10.34,11.24-14.19,1.35-1.08,3.75-3.81,4.55.52.08.45-.43,1.44-.46,1.97-.09,1.43.16,2.05,1.09,3.1.23.26.65.35.97.26,1.38-.41,1.9-.59,3.09-1.49.75-.67,1.49-1.36,2.19-2.07,3.64.41,4.46,1.53,2.45,3.37-1.59,3.8-5.11,7.5-7.42,10.89-1.41,2.07-2.83,4.15-4.24,6.22-.56.83-4.49,6.89-5.71,4.57-.86-1.63,2.08-6.89,2.81-8.16s2.1-2.53,2.49-3.88c1.38-4.65-3.2-3.83-6.08-2.51-.68.31-6.34,4.67-7.1,3.4-.58-.99,2.68-5.71,3.35-6.64,1.5-2.06,3.28-3.7,5.28-5.25,1.02-.79-.41-2.19-1.41-1.41h0Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st106",
    cx: 247.66,
    cy: 284.46,
    rx: 15.08,
    ry: 20.81,
    transform: "translate(-121.3 206.18) rotate(-36.98)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st55"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M238.77,273.96l-.31-.48c-1.01.52-1.92,1.32-2.33,2.38s-.22,2.39.65,3.13c1.13.97,3.01.71,4.02,1.8,1.04,1.12.68,3.2,1.94,4.07.83.57,2.05.27,2.76-.45s1-1.76,1.13-2.76c.3-2.31-.18-4.8-1.71-6.56s-4.23-2.54-6.31-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M239.21,273.71l-.31-.48c-.14-.23-.44-.32-.68-.18-2.4,1.4-4.31,5.17-.98,6.79.92.45,1.88.48,2.72,1.12,1.12.85,1,1.71,1.49,2.9.45,1.1,1.3,1.89,2.55,1.78,6.45-.57,2.75-15.96-5.53-12.53-.59.24-.33,1.21.27.96,2.99-1.24,6.06.58,7.05,3.55.45,1.35.61,3.09.26,4.49-.13.5-.45,1.72-.9,1.94l-2.61-.18c-.16-.35-.28-.71-.37-1.09-.37-1.19-.62-2.25-1.78-2.91-.62-.35-1.32-.45-1.98-.66-2.97-.96-1.83-4.05.3-5.3l-.68-.18.31.48c.34.54,1.21.04.86-.5h0Z"
  })))))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "ear3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 266.45,
    cy: 410.87,
    r: 15.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M259.95,410.21c-.93-3.11.21-6.38,2.65-7.97,2.98-1.95,7.43-1.09,9.73,2.31"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "left_eye3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M324.85,388.33c-.44-3.44,1.64-6.72,4.87-7.76,3.37-1.08,7.1.54,8.65,3.8"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "right_eye3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M364.06,379c-.46-3.39,1.77-6.6,5.09-7.36,3.31-.76,6.69,1.15,7.77,4.38"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "nose"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M352.73,380.24s14.85,17.86,0,22.66"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "mouth"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M337.7,409.69c3.46,18.14,13.88,28.87,20.09,27.82,6.09-1.03,12.16-14.12,10.17-31.58-10.09,1.25-20.17,2.51-30.26,3.76Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st56"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M346.45,435.58s4.91-19.29,21.27-6.89l-1.68,7.51-12.23,4.34-7.36-4.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M341.04,407.43l.24,1.26c.77,4,4.53,6.71,8.57,6.16l7.84-1.05c4.44-.6,7.43-4.85,6.49-9.23h0s-23.15,2.86-23.15,2.86Z"
  }))))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "smores3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "M359.14,462.37c-.41,2.18.72,4.43,2.36,5.93s3.72,2.41,5.76,3.29c15.89,6.83,31.79,13.66,47.68,20.49,3.57,1.53,7.28,3.1,11.16,2.95s7.97-2.53,8.75-6.33c.58-2.83-.78-5.77-2.82-7.82s-4.69-3.35-7.28-4.62c-9.5-4.65-19.03-9.33-29.1-12.56-6.91-2.22-14.09-3.76-21.36-4.07-3.19-.14-6.42-.19-9.55-.36-2.48-.13-4.98-.29-5.61,3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M364.42,469.25c.52,2.26,1.97,4.77,3.8,4.24,2-.58,2.39-4.21,4.23-5.36,1.9-1.19,4.2,1.1,4.67,3.68s-.21,5.24-.58,7.85-.3,5.65,1.27,7.44c2.4-.45,3.98-3.41,4.7-6.31s.89-6.03,2.02-8.71,3.71-4.82,5.95-3.64c1.9,1.01,2.65,3.89,2.77,6.46s-.16,5.25.59,7.64,3.12,4.29,4.88,2.96c-1.55,1.34.32,4.66,2.2,4.35s3.17-2.38,4.53-4.02,3.52-2.95,5.05-1.57c3.05,2.76-1.46,10.65,1.82,12.98,2.47,1.75,4.72-2.79,7.37-4.06,2.55-1.22,5.86.65,7.93-1.57,1.59-1.71,1.36-5.05.08-7.13s-3.3-3.19-5.23-4.23c-12.3-6.62-24.59-13.25-37.05-19.38-4.43-2.18-11.73-7.82-16.59-7.21-5.38.67-5.54,10.54-4.38,15.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M363.88,454.02c-1.38,1.72-1.92,4.15-1.17,6.22.87,2.4,3.17,3.93,5.34,5.29,1.89,1.19,3.81,2.39,5.93,3.09s4.5.86,6.56-.02c3.02-1.31,4.79-4.82,4.42-8.1s-2.63-6.17-5.54-7.71c-4.26-2.26-12.2-2.91-15.54,1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M380.79,467.95c.36,2.02,1.67,3.78,3.29,5.03s3.54,2.06,5.47,2.75c2.45.87,5.31,1.55,7.53.19,2.08-1.26,2.88-4.07,2.26-6.42-1.11-4.2-6.28-7.02-10.04-8.49-4.47-1.75-9.4,1.84-8.5,6.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M399.16,477.25c2.21,1.47,5.24,1.98,8.15,2.32,4.26.51,9.29.57,12.09-1.92,2.96-2.63,1.59-6.97-1.84-9.26-4-2.66-10.6-4.03-15.5-2.29-5.68,2.02-8.14,7.66-2.9,11.14Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M398.97,414.77l41.93,15.1c6.19,2.23,9.52,8.96,7.52,15.23l-8.83,27.82c-2.21,6.96-9.99,10.46-16.66,7.48l-56.84-25.32c-8.57-3.82-9.84-15.45-2.31-21.03l23.74-17.6c3.29-2.44,7.59-3.07,11.45-1.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st57"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M372.43,437.23c-.95.73-1.34,2.12-.89,3.22.56,1.36,2.38,2.04,3.69,1.37s1.83-2.54,1.06-3.79-2.68-1.62-3.87-.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M384.51,428.06c-.95.73-1.34,2.12-.89,3.22.56,1.36,2.38,2.04,3.69,1.37s1.83-2.54,1.06-3.79-2.68-1.62-3.87-.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M395.09,419.54c-.95.73-1.34,2.12-.89,3.22.56,1.36,2.38,2.04,3.69,1.37s1.83-2.54,1.06-3.79-2.68-1.62-3.87-.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M397.53,435.37c-.95.73-1.34,2.12-.89,3.22.56,1.36,2.38,2.04,3.69,1.37s1.83-2.54,1.06-3.79-2.68-1.62-3.87-.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M388.51,446.37c-.95.73-1.34,2.12-.89,3.22.56,1.36,2.38,2.04,3.69,1.37s1.83-2.54,1.06-3.79-2.68-1.62-3.87-.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M404.22,454.63c-.95.73-1.34,2.12-.89,3.22.56,1.36,2.38,2.04,3.69,1.37s1.83-2.54,1.06-3.79-2.68-1.62-3.87-.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M408.19,426.96c-.95.73-1.34,2.12-.89,3.22.56,1.36,2.38,2.04,3.69,1.37s1.83-2.54,1.06-3.79-2.68-1.62-3.87-.74"
  }))))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "left_hand_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M461.32,510.79c7.7,18.62,26.24,30.2,45.45,28.75,21.51-1.63,39.5-19.26,41.73-41.92.68-6.76,2.55-31.34-13.75-55.11-9.25-13.5-24.38-26.36-48.96-34.39,0,0-46.1-19.69-71.67,3.5,0,0-20.88,26.26-5.06,44.3,0,0-5.32,13.45,12.59,18.95,0,0-4.69,10.63,11.39,16.91,5.14,2.01,10.7,2.72,16.2,2.35l9.7-.66s-7.51.2,2.38,17.32Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st53"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M409.81,454.18s14.45-24.94,45.13-7.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M422.28,473.62s4.82-14.9,37.7-3.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M459.97,492.44s21.98-13.17,36.24,15.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M454.94,439.25s2.98,6.28-1.34,13.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M459.29,463.57s3.13,5.11-1.63,12.99"
  }))))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "face_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st8",
    cx: 474.4,
    cy: 787.17,
    rx: 65.46,
    ry: 69.53
  }), /*#__PURE__*/React.createElement("g", {
    className: "st75"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 497.64,
    cy: 783.15,
    r: 6.71
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M436.68,753.77c3.25-2.04,7.31-2.22,10.61-.43,4.44,2.4,5.24,7.14,5.33,7.68"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "left_eyebrow4"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 508.62,
    cy: 751.43,
    rx: 9.44,
    ry: 4.44,
    transform: "translate(-276.25 296.1) rotate(-25.79)"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "left_eye4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M511.68,767.66c-1.36-3.11-.21-6.76,2.62-8.49,2.95-1.8,6.9-1.02,8.98,1.84"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "hair_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M442.25,765.4c2.62-.15,20.68-1.51,30.63-16.31,3.89-5.79,5.19-11.64,5.66-15.52,11.16,7.01,24.95,7.33,35.04.59,11.57-7.73,13.13-20.98,13.33-22.91.08-.85,1.15-13.94-9.09-21.9-7.92-6.15-19.24-6.63-28.24-1.08-2.87-10.49-11.05-18.61-21.29-20.98-12.02-2.79-24.91,2.8-31.6,13.94-14.38-7.54-31.9-5.91-44.54,4.14-12.93,10.28-18.41,27.5-13.8,43.47-27.01,15.99-38.07,46.42-28.67,69.72,6.35,15.74,21.94,28.02,39.74,30.19,21.94,2.68,43.39-10.45,49.92-25.57.05-.12.11-.24.16-.37,7.17-16.94,4.07-32.22,2.77-37.44Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st69"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M459.27,679.13c-5.77.8-11.23,3.73-15.09,8.1-.79.9-1.52,2.33-.68,3.19.98,1.02,2.6-.1,3.79-.87,2.19-1.43,5.16-1.55,7.46-.31-2.93,2.39-5.31,5.44-6.92,8.86-.66,1.4-1.18,3.12-.36,4.45.91,1.48,3.1,1.66,4.66.9s2.68-2.17,3.85-3.45c3.8-4.16,8.72-7.29,14.09-8.96,1.18-.37,2.4-.68,3.41-1.38s1.78-1.92,1.54-3.13c-.37-1.93-2.87-2.58-4.8-2.24s-3.84,1.27-5.77.92c2.11-2.87,4.22-5.75,6.33-8.62-5.28-1.8-11.24-1.51-16.32.79s-9.23,6.59-11.37,11.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M458.88,677.69c-5.52.95-14.65,4.3-16.85,10.18-.58,1.55-.42,3.14,1.08,4,1.36.78,1.92.32,3.29-.07,2.71-.77,4.95-2.32,7.95-1.1l-.66-2.51c-3.23,2.82-10.9,10.6-7.29,15.42,4.32,5.77,10.48-2.76,13.4-5.21,3.82-3.22,7.9-4.64,12.43-6.49,1.85-.76,3.74-1.86,4.19-3.99,1.59-7.36-8.82-4.11-11.97-4.21l1.3,2.26c2.11-2.87,4.22-5.75,6.33-8.62.59-.81-.05-1.95-.9-2.2-11.97-3.56-24.18,1.82-29.38,13.23-.8,1.74,1.79,3.27,2.59,1.51,4.66-10.21,15.19-15.06,26-11.85l-.9-2.2c-2.11,2.87-4.22,5.75-6.33,8.62-.71.97.26,2.22,1.3,2.26,1.73.06,3.03-.38,4.72-.64,5.32-.8,2.97,1.99.5,3.53-2.9,1.8-6.36,2.53-9.27,4.56-1.15.81-2.26,1.68-3.31,2.62s-2.26,2.98-3.51,3.61c-1.12,1.45-2.75,1.32-4.88-.4.51-1.4,1.17-2.72,1.98-3.96,1.41-2.22,3.16-4.01,5.12-5.72.94-.82.29-2.12-.66-2.51-1.63-.66-3.19-1.04-4.95-.83-.65.08-1.27.33-1.91.44-.96.16-1.45,1.58-1.85.29-.48-1.54,4.07-3.88,5.34-4.54,2.52-1.32,5.11-2.09,7.9-2.57,1.9-.33,1.09-3.22-.8-2.89h0Z"
  })))))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "ear4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 435.91,
    cy: 789.51,
    r: 14.63
  }), /*#__PURE__*/React.createElement("g", {
    className: "st70"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M429.02,788.29c0-2.68,1.34-5.15,3.57-6.44,2.73-1.59,6.34-1.14,8.81,1.17"
  }))))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "mouth4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M517.2,790.98c3.72,11.21,8.61,19.75,12.37,19.29,4.08-.5,7.09-11.6,7.22-27.25-6.53,2.65-13.06,5.31-19.59,7.96Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st71"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M521.81,808.31s4.74-11.54,13.91-3.8l-1.99,4.79-5.35,3.41-6.57-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M519.86,787.98h0c1.07,3,4.41,4.53,7.38,3.37l2.67-1.04c2.84-1.11,4.28-4.26,3.27-7.14l-.14-.39-13.18,5.19Z"
  }))))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "pony_tail4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M361.27,674.23c-8.48,1.3-15.86,6.63-21.73,12.89s-10.53,13.55-15.96,20.19c-5.43,6.64-11.89,12.82-19.94,15.79-11.04,4.07-23.4,1.56-34.53-2.25-11.14-3.81-22.03-8.92-33.74-10.05-15.32-1.48-30.78,4.15-43.08,13.4-12.3,9.25-21.68,21.9-29.17,35.34-8.79,15.75-15.29,33.29-15.1,51.33s7.89,36.61,22.76,46.82c14.88,10.2,37.12,9.9,49.71-3.02,18.9-19.41,10.43-56.32,31.59-73.24,10.36-8.28,24.65-8.88,37.87-9.95s27.81-3.78,35.78-14.39c6.06-8.06,6.78-18.76,9.21-28.55,2.08-8.39,6.75-18.15,15.52-21.16,8.34-2.85,18.33,3.32,26.25-1.28,18.41-10.69,2.43-34.62-15.44-31.88Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st72"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M193.84,738.94c-4.86,5.48-9.18,11.43-12.9,17.75-.5.85-1.01,1.77-1,2.76s.74,2.05,1.73,2.04c.63,0,1.17-.41,1.67-.79,4.09-3.19,8.19-6.39,12.28-9.58-3.6,6.6-7.21,13.2-10.81,19.8-.87,1.59-1.75,3.24-1.87,5.05s.76,3.81,2.48,4.4c1.5.52,3.21-.2,4.32-1.33s1.77-2.63,2.46-4.06c4.27-8.87,10.54-16.76,18.21-22.92,1.22-.98,2.5-1.94,3.34-3.26s1.14-3.11.3-4.43c-.9-1.42-2.86-1.86-4.5-1.48s-3.04,1.42-4.39,2.43c.09-3.79,1.52-7.53,3.98-10.42,1.86-2.18,4.45-5.03,2.84-7.4-1.55-2.28-5.11-1.11-7.39.44-8.97,6.1-16.13,14.82-20.39,24.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M192.78,737.88c-3.7,4.24-7.15,8.68-10.23,13.38-1.57,2.4-5.3,6.53-3.74,9.73.9,1.86,2.7,2.32,4.51,1.54,2.01-.87,3.99-3.04,5.69-4.37,2.56-2,5.12-3.99,7.68-5.99l-2.36-1.82c-3,5.5-6.01,11-9.01,16.5-1.7,3.12-4.62,7.05-3.73,10.87.59,2.53,2.7,4.5,5.38,4.25,4.07-.37,5.65-4.6,7.26-7.72,2.7-5.23,6.07-10.11,10.06-14.44,3.16-3.43,8.18-6.2,10.64-10.12,1.47-2.35,1.59-5.61-.82-7.4-3.18-2.37-7-.23-9.7,1.72l2.26,1.3c.39-5.29,2.82-7.74,5.58-11.87,1-1.5,2.04-3.23,1.67-5.13-.73-3.74-4.75-4.02-7.7-2.91-4.99,1.88-9.66,6.76-13.12,10.65-4.23,4.75-7.6,10.1-10.17,15.92-.78,1.75,1.81,3.28,2.59,1.51,3.62-8.18,8.9-15.52,15.83-21.22,1.42-1.17,4.03-3.87,6.05-4.04,1.37-.9,1.81-.21,1.32,2.05.79,1.24.74,2.24-.15,3-.12.3-1.03,1.27-1.21,1.52-2.33,3.16-3.4,6.64-3.69,10.53-.08,1.08,1.36,1.95,2.26,1.3,1.21-1.54,2.41-1.32,3.59.67,2.36.64,2.91,1.37,1.64,2.2-.45.98-2.2,1.83-3.06,2.56-2.08,1.77-4.06,3.66-5.92,5.67-3.42,3.7-6.45,7.8-8.97,12.17-.76,1.31-3.23,7.94-4.53,8.1l-4.07-2.94.86-2.16c.59-1.26,1.33-2.46,1.99-3.68,3.15-5.78,6.31-11.55,9.46-17.33.87-1.59-1.07-2.82-2.36-1.82-2.3,1.8-4.61,3.59-6.91,5.39-.6.47-3.04,3.08-3.84,3-2.51-.28-.89-2.15-.15-3.34,3.32-5.35,7.1-10.35,11.24-15.09,1.26-1.45-.85-3.58-2.12-2.12h0Z"
  })))))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "shoe4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M676.06,1230.92s3.9,99.58,83.4,52.04l80.87-50.25c11.05-6.86,19.33-17.53,22.72-30.09,2.65-9.82,2.53-21.2-6-30.95s-22.78-13.59-35.48-9.67l-57.4,17.7c-19.76-15.66-47.1-16.54-66.52-2.66-16.64,11.9-25.03,32.89-21.59,53.87"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M721.35,1278.71c9.85,1.45,19.41-3.46,28.1-8.32,19.48-10.89,38.68-22.3,57.56-34.21,13.5-8.51,27.1-17.52,36.84-30.16,9.73-12.65,15.07-29.75,9.97-44.87,14.14,7.71,19.38,26.45,15.68,42.12s-14.47,28.69-26.01,39.93c-27.19,26.47-60.63,46.48-96.81,57.93-12.16,3.85-25.07,6.76-37.62,4.47-10.77-1.97-31.63-13.48-27.09-27.61,5.53-17.22,29.32-.75,39.39.73Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M795.84,1194.49c6.14-.32,11.98-2.62,17.66-4.97,7.23-3,14.75-6.41,19.38-12.73s5.02-16.42-1.24-21.14c-3.78-2.85-8.89-3.08-13.61-2.7-12.86,1.01-31.8,6.34-40.29,17-9.43,11.84,6.58,25.15,18.1,24.55Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st76"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M786.44,1171.18s13.19.67,8.65,16.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M802.81,1164.92s13.83,3.82,8.43,19.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M817.45,1160.45s13,4.33,8.56,17.57"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M677.59,1272.38c3.29-6.67,10.58-11.27,18.02-11.02,7.44.25,14.53,5.54,16.56,12.7s-1.41,15.58-8.03,18.97c-6.97,3.57-16.08,1.15-21.38-4.62-5.64-6.14-7.2-15.71-3.79-23.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M733.4,1225.36c6.37.72,12.62-1.76,18.55-4.19,10.79-4.42,21.59-8.84,32.38-13.26,2.73-1.12,5.55-2.25,8.5-2.26s6.1,1.4,7.28,4.1c.92,2.11.47,4.62-.64,6.64s-2.82,3.63-4.53,5.17c-6.6,5.96-13.65,11.41-21.07,16.31-7.31,4.82-15.06,9.14-23.49,11.51-8.43,2.36-17.63,2.67-25.82-.42-8.19-3.09-15.2-9.85-17.4-18.33-1.21-4.67-.83-9.98,2.08-13.83,2.86-3.77,9.24-6.39,11.78-1.71,2.92,5.38,5.5,9.48,12.38,10.26Z"
  }))))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    id: "left_lower_leg4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M676.06,1230.92s-58.58-59.82-103.01-152.03c-8.68-18.01-9.47-38.98-1.53-57.33.25-.59.52-1.18.79-1.77.1-.21.19-.42.29-.62,13.15-27.81,44.15-42.07,74.08-34.97,3.92.93,7.98,2.19,12.11,3.84,24.12,9.68,36.61,27.32,40.69,33.69,9.68,10.93,20.04,24.12,29.18,40.17,15.12,26.55,31.29,66.05,35.51,117.8,0,0-25.89,51.22-88.11,51.22Z"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "left_thigh4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M306.16,1062.96s-36.58,77.14,51.59,128.47c27.33,15.91,58.4,24.36,90.02,24.91,57.94,1,156.77-17.99,230.06-140.5,25.03-41.83-6.44-94.9-55.14-92.87-22.65.94-51.59,7.19-88.54,22.06l-228,57.92Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st77"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M486.47,1099.18s28.11,24.46-6.1,58.67"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M616.41,1151.5s19.43-20.67,19.43-62.25"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    id: "right_leg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M1246.46,512.47s-121.75-17.95-145.17,99.66l-17.29,135.59s21.23,28.93,77.75,22.27l29.26-137.37,125.13-89.39-69.68-30.76Z"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "body4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M430.93,822.83s-51.05-29.23-94.58,36.58c0,0-69.75,85.95-41.85,182.16,0,0,13.88,74.2,101.51,73.92,55.76-.18,101.67-44.85,102.61-100.6.02-.99.03-1.98.03-2.99,0,0,.79-121.97-67.72-189.06Z"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    id: "coat4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M406.51,816.47s-85.6-13.01-124.87,149.45c11.11,10.26,33.63,28.28,67.36,37.71,41.92,11.72,77.02,3.42,91.71-.96-50.87-24.98-79.84-74.35-73.12-120.59,5.16-35.54,29.78-58.04,38.93-65.61"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    id: "upper_arm"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M398.31,817.7s41.12-15.9,153.98,96.96c24.88-12.77,54.84-9.19,75.07,8.8,1.79,1.6,3.5,3.33,5.12,5.19,23.96,27.49,18.1,69.81-11.65,90.9-17.66,12.51-42.84,24.97-74.56,27.26-36.67.22-73.14-17.35-126.88-57.28-16.47-12.23-23.51-18.51-40.15-33.34-22.29-19.86-37.24-46.63-33.47-75.43,3.87-29.52,23.22-52.59,52.53-63.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M403.51,976.56s15.93,16.8,35.2,26.7"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    id: "lower_arm4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M664.84,902.24s10.46,50.45-15.69,91.77c-27.65,43.7-93.08,36.01-108.66-13.52,0,0,0-.01,0-.02-.47-1.5-.74-3.06-.86-4.63-.92-12.17-2.42-64.77,37.44-90.26,0,0,29.9,23.41,87.77,16.65Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st78"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M584.8,910.07s31.35,22.79,71.24,7.73"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M552.3,914.67s-14.14,27.01,16.96,44.97"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    id: "smores4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M525.01,832.47c-1.73.71-3.22,2.33-3.17,4.2.06,2.37,2.37,3.97,4.44,5.14,15.63,8.77,32.13,15.99,49.18,21.52,3.15,1.02,7.23,1.72,9.24-.9,1.53-1.99.87-5.02-.8-6.9s-4.08-2.88-6.41-3.83c-9.31-3.78-18.62-7.55-27.93-11.33-4.57-1.85-9.13-3.71-13.7-5.56-1.81-.73-3.61-1.89-5.41-2.54-2.09-.75-3.4.2-5.44.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M524.92,835.93c-1.26,2.29-2.61,4.77-1.68,7.44.5,1.43,1.84,2.48,3.35,2.36,1.92-.15,2.77-1.98,3.78-3.42.89-1.27,2.53-2.45,3.88-1.69,2.54,1.43-.33,6.64,2.33,7.84,1.54.69,3.05-.94,3.97-2.35s2.55-2.98,4.02-2.17c2.28,1.26-.09,5.77,2.18,7.05,1.38.78,2.99-.57,3.89-1.87.96-1.39,2.2-3.08,3.93-2.62,1.05.28,1.71,1.31,1.78,2.4.12,2-1.14,3.53-2.04,5.18s-1.42,3.85.3,5.25c1.03.84,2.49.9,3.71.37,2.57-1.12,3.6-3.71,4.79-6.04.99-1.94,2.26-3.89,4.45-4.53.95-.28,2.01-.18,2.86.34,1.57.95,1.54,2.53,1.49,3.99l-.1,2.49c-.06,1.61,1.49,2.78,3.03,2.31.47-.14.95-.25,1.41-.34,2.14-.38,4.63-.75,5.53-2.9.52-1.26.25-2.7-.5-3.84-1.34-2.03-3.62-2.89-5.81-3.69-4.13-1.52-8.26-3.04-12.39-4.56-7.5-2.76-14.99-5.51-22.49-8.27-3.32-1.22-7.24-3.44-10.73-3.92s-3.54,2.69-4.91,5.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M526.16,825.98c-1.18,2.01-.92,4.76.62,6.51,1.28,1.46,3.21,2.14,5.05,2.77,1.98.67,3.96,1.35,5.93,2.02,1.78.61,3.76,1.21,5.5.47,2.01-.86,2.93-3.38,2.49-5.52s-1.96-3.91-3.69-5.25c-3.77-2.94-12.63-6.55-15.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M544.01,839.19c.67,1.26,2.04,1.96,3.34,2.57,2.39,1.13,4.78,2.27,7.17,3.4,1.61.76,3.34,1.54,5.1,1.25,2.69-.44,4.43-3.49,4.02-6.19-.74-4.93-6.5-7.5-10.89-8.2-3.55-.57-11.29,2.34-8.74,7.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M562.9,845.93c.34,1.06,1.17,1.89,2.03,2.6,3.59,2.97,8.19,4.69,12.85,4.79,1.33.03,2.68-.07,3.91-.59s2.3-1.49,2.68-2.76c.56-1.87-.48-3.85-1.79-5.29-3.02-3.31-7.54-4.5-11.83-5.09-3.39-.46-9.27,1.9-7.85,6.33Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M548.05,789.12l59.65,19.63c3.16,1.04,5.2,4.12,4.91,7.44l-2.95,33.83c-.42,4.85-5.46,7.88-9.95,5.98l-69.46-29.41c-3.88-1.64-5.51-6.25-3.54-9.97l12.76-24.05c1.64-3.09,5.26-4.55,8.58-3.45Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st74"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 538.66,
    cy: 819.93,
    r: 1.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 545.85,
    cy: 807.51,
    r: 1.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 552.48,
    cy: 796.65,
    r: 1.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 550.61,
    cy: 827.25,
    r: 1.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 557.27,
    cy: 815.06,
    r: 1.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 563.7,
    cy: 802.01,
    r: 1.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 562.68,
    cy: 832.58,
    r: 1.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 569.26,
    cy: 820.35,
    r: 1.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 575.48,
    cy: 808.39,
    r: 1.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 575.48,
    cy: 839.21,
    r: 1.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 582.66,
    cy: 827.25,
    r: 1.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 594.88,
    cy: 833.82,
    r: 1.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 591.06,
    cy: 845.38,
    r: 1.87
  }))))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    id: "lhand_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M576.19,883.16c.57,1.63,1.47,3.12,2.67,4.36,5.58,5.79,18.69,17.36,39.22,21.28,17.09,3.26,31.36-.32,39.91-3.54,4.35-1.64,7.34-5.64,7.69-10.27,1.2-15.68.49-51.53-26.14-81.46-11.49-12.91-27.89-24.11-51.25-30.88-16.73-4.84-30.06,14.19-19.67,28.17.16.22.33.44.51.67,3.63,4.67,8.76,7.85,14.38,9.69s9.88,5.7,12.14,10.94c.04.1.08.19.12.29,3.21,7.75-2.57,16.22-10.96,16.37-10.22.18-17.09,10.09-8.62,34.4Z"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    id: "left_thigh7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M1280.58,534.2s-112.29,16.86-135.3,68.39c-4.76,10.66-2.08,29.44,7.8,35.67,19.76,12.47,68.74,28.78,188.89,24.59,17.53-.61,34.87-4.18,51.03-10.99,23.27-9.81,49-28.07,48.22-60.75-.72-30.25-23.85-55.31-53.82-59.51-26.42-3.7-65.26-5.94-106.82,2.59Z"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    id: "right_shoe"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1081.8,763.71l-.2,1.45s-76.59,10.34-71.54,46.22c0,0,15.54,34.17,83.67,21.12l57.82-15.48c12.03-3.22,19.78-14.9,18.07-27.24l-3.12-22.43c-.25-1.82-.6-3.62-1.11-5.39-5.23-18.1-20.48-31.43-38.56-33.61-.59-.07-1.17-.13-1.76-.18-21.46-1.71-40.35,14.2-43.27,35.53Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1040.79,803.2s63.87-3.94,113.57-21.44"
  }))))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    id: "left_shoe7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1151.33,791.23s-1.45,7.13-15.77,9.5c0,0-85.35,4.66-85.35,57.46,0,0-2.36,37.72,105.93,26.31l36.66-5.36c20.81-3.04,37.73-18.45,42.49-38.93.7-3.02,1.35-6.15,1.93-9.38,3-16.66,3.37-31.31,2.84-42.79-5.24-19.33-21.53-33.26-40.14-34.8-22.11-1.82-43.57,14.19-48.59,37.99"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M1249.15,838.01c6.27-3.29,13.85-6.88,20.02-3.41,6.32,3.56,6.95,13.04,3.14,19.21s-10.61,9.75-17.17,12.84c-27.75,13.08-57.14,22.65-87.27,28.43-36.4,6.98-76.02,7.92-108.45-10.01-4.79-2.65-9.48-5.79-12.58-10.3-9.08-13.2,1.9-23.93,14.98-19.75,14.71,4.7,29.76,7.84,45.13,9.51,31.13,3.39,62.89.9,93.11-7.3,16.99-4.61,33.5-11.03,49.09-19.21Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M1081.82,821.1c-4.77,1.9-9.95,4.56-11.67,9.64-2.19,6.48,2.53,13.5,8.21,16.86,6.77,4,14.92,4.72,22.6,3.58,7.68-1.14,15.02-4.03,22.28-6.89,7.03-2.77,15.14-6.89,16.2-14.76.76-5.7-2.9-11.3-7.68-14.05-14.56-8.37-35.8,0-49.94,5.62Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st35"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 1086.62,
    cy: 826.57,
    rx: 2.63,
    ry: 2.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 1101.29,
    cy: 822.5,
    rx: 2.63,
    ry: 2.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 1117.51,
    cy: 818.82,
    rx: 2.63,
    ry: 2.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 1129.35,
    cy: 831.36,
    rx: 2.63,
    ry: 2.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 1111.28,
    cy: 837.51,
    rx: 2.63,
    ry: 2.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 1098.83,
    cy: 842.21,
    rx: 2.63,
    ry: 2.04
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1114.89,860.21s67.4.42,114.74-19.49"
  }))))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    id: "lower_leg7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M1230.88,599.37c-30.8-29.09-81.77-13.06-91.13,28.25-4.81,21.19-6.71,52.88,2.26,98.1l9.33,65.5s48.2,28.94,88.73-3.19c0,0,16.49-78.02,14.27-136.14-.73-19.1-8.34-37.43-21.83-50.96-.53-.53-1.06-1.05-1.61-1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1159.95,582.65s-48.05,26.45-8.62,208.58"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    id: "legs_6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M1689.42,651.59s112.06,127.55-123.28,150.92c0,0,5.53,59.51-12.04,132.16l-221.62-16.86c-7.32-47.26-14.63-94.53-21.95-141.79-14.11-45.53-3.14-92.56,28.06-119.58,22.86-19.8,49.67-22.86,61.34-23.43l121.07,20.15,168.42-1.56Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1566.14,802.51s2.45-27.97-29.06-39.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1540.32,681.77s-36.6-15.16-100.04,13.7"
  }))))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    id: "rightupper_arm7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M1339.04,378.12c1.17,5.03,3.05,10.44,5.81,16.24,0,0-29.37,66.14-22.6,161.6.64,9.09,4.92,17.68,12.11,23.39,3.01,2.38,6.67,4.43,11.07,5.57,15.2,3.93,32.91-4.58,41.11-21.37,12.31-17.98,24.78-46.12,37.63-80.89,16.13-43.62,26.88-93.6,5.38-119.04,0,0-11.03-13.81-33.42-24.04-29.76-13.6-63.9,9.36-57.08,38.55Z"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    id: "lower_arm_7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M1329.33,431.65s119.19,20.86,76.94,117.95c-11.83,27.19-49.64,43.38-80.2,34.74-22.23-6.29-45.9-30.3-66.93-79.51,0,0,70.19,7.1,70.19-73.18Z"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    id: "body6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M1558.57,443.1s170.07,57.95,147.08,192.26c-5.92,34.6-30.27,63.23-63.23,72.63-21.6,6.16-90.73-9.63-145.48-34.07-27.63-12.34-45.27-40.6-44.57-71.53l2.81-123.7,103.38-35.58"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1559.16,567.05s21.73,5.89,35.46,19.62c0,0-10.39-24.07-1.83-38.88"
  }))))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    id: "right_arm6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M1358.25,534.64c-4.23,18.93-6.19,40.77-.85,60.71,10.13,37.8,48.54,56.39,81.03,40.18,19.03-9.5,41.61-30.1,63.32-72.74,16.56-32.51,12.28-73.57-11.73-99.79-15.14-16.53-37.33-26.23-69-11.29-31.63,14.92-54.53,46.02-62.78,82.94Z"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    id: "left_arm_7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M1136.42,400.07s-49.43,107.17,35.19,117.15c0,0,1.54.07,4.15-.13,31.23-2.3,54.1-30.44,50.4-61.53-2.41-20.18-7.74-48.44-19.45-65.41,0,0-23.72,19.83-70.28,9.91Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1137.49,442.59s39.55,32.9,67.96-1.57"
  }))))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    id: "body_7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M1335.74,337.1c29.09-7.49,56.09,6.14,63.36,26.78,6.56,18.63-5.12,36.82-6.89,39.49-14.06,47.46-28.13,94.91-42.19,142.37,0,0-69.96,25.67-121.25-25.62l-18.62-93.43c-.94-1.1-15.25-18.41-8.66-39.6,5.06-16.29,20.34-28,38.27-29.09,32-6.97,63.99-13.93,95.99-20.9Z"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    id: "right_hand_6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M1477.11,498.35s4.46,37.81-25.74,56.55c-19.07,11.83-43.42,10.09-61.54-3.16-12.54-9.18-25.3-24.47-29.28-49.61,0,0-6.84-42.51,42.61-61.49,0,0,27.32-9.78,39.52,17.02,1.75,3.48,1.58,7.28-.46,9.63-1.03,1.19-2.32,1.76-3.26,2.05.38.68,2.36,4.21.92,8.12-.98,2.67-3.63,5.39-9.7,7.08,0,0,7.28,12.53-18.31,14.81,0,0-5.14.22-11.69,4.19,0,0,7.5,4.7,7.5,13,0,0,37.5,5.73,69.41-18.21Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st46"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1428.62,484.56s-16.05-19.18-37.57.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1438.97,469.36s-13.51-22.47-42.65-5.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1395.42,459.19s-1.03,4.45,2.08,9.12"
  }))))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    id: "face6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st8",
    cx: 1508.67,
    cy: 428.23,
    rx: 63.59,
    ry: 67.84
  }), /*#__PURE__*/React.createElement("g", {
    className: "st47"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 1473.18,
    cy: 430.21,
    r: 3.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 1528.06,
    cy: 444.64,
    r: 3.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1504,421.12s-9.05,9.57-1.41,15.08"
  }))))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    id: "left_eye6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1477.34,419.52c1.05-2.18,3.46-3.36,5.78-2.84,2.41.54,4.13,2.8,4,5.33"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    id: "right_eye6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1523.07,432.07c1.07-2.27,3.58-3.48,5.95-2.93,2.51.58,4.27,3,4.03,5.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1500.96,435.54"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    id: "left_eyebrow6"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1484.65,
    cy: 407.85,
    rx: 5.06,
    ry: 8.69,
    transform: "translate(770.93 1772.08) rotate(-77.74)"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    id: "right_eyebrow6"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1532.33,
    cy: 420.34,
    rx: 5.25,
    ry: 8.75,
    transform: "translate(651.31 1742.66) rotate(-71.67)"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    id: "mouth6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1486.19,434.67c-4.91,14.62,1.34,27.42,8.15,29.35,6.91,1.96,19.24-5.91,22.4-21.43-10.18-2.64-20.36-5.28-30.55-7.92Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M1484.51,455.92s13.32-8.54,21.97,6.44l-6.61,5.63s-14.67-2.47-15.88-3.68c-1.21-1.21.52-8.4.52-8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M1489.87,434.67h0c-.7,3.25,1.06,6.51,4.16,7.72,2.82,1.1,6.58,2.31,10.82,2.97,3.51.55,6.86-1.69,7.67-5.15l.17-.73-22.81-4.81Z"
  }))))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    id: "smores_6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M1512.79,505.84c1.39-1.95,2.81-3.95,3.41-6.27.6-2.32.21-5.05-1.59-6.63-2.11-1.86-5.48-1.54-7.85-.03s-3.96,3.95-5.48,6.31c-3.95,6.15-7.91,12.3-11.86,18.45-1.45,2.26-2.92,4.55-3.71,7.12s-.84,5.48.48,7.82c4.7,8.3,9.96-3.46,12.58-7.14,4.67-6.54,9.34-13.09,14.01-19.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M1501.31,516.97c1.01-.73,2.03-1.46,3.04-2.2.75-.54,1.58-1.21,1.64-2.14.07-1.1-.94-1.91-1.73-2.66s-1.48-2.04-.77-2.87c1.33.52,2.65,1.05,3.98,1.57.93-.72,1.01-2.1.78-3.25-.23-1.15-.7-2.29-.57-3.46.18-1.54,1.36-2.77,2.61-3.69s2.64-1.7,3.6-2.92,1.33-3.09.35-4.29c-.9-1.09-2.6-1.19-3.89-.61s-2.24,1.7-3.12,2.79c-4.05,5.04-7.54,10.53-10.39,16.33-.89,1.82-3.63,5.82-2.64,7.9,1.41,2.95,5.39.73,7.11-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M1489.62,521.52c1.21.86,2.98.5,4.1-.46s1.74-2.39,2.21-3.8.83-2.87,1.6-4.14c.92-1.51,2.36-2.63,3.57-3.93s2.24-2.97,2.03-4.73c-.22-1.83-1.83-3.31-3.63-3.67s-3.71.25-5.19,1.35-2.57,2.64-3.46,4.25c-2.02,3.68-3.08,7.87-3.05,12.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M1505.69,500.42c.86-1.82,1.28-3.88,2.53-5.45,1.2-1.52,3.01-2.4,4.62-3.48,1.61-1.08,3.16-2.6,3.31-4.53.2-2.62-2.47-4.78-5.09-4.85s-5.04,1.41-6.99,3.16c-3.03,2.72-7.06,7.52-6.93,11.86.16,5.38,5.57,9.57,8.56,3.29Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M1394.05,493.47l55.94-43.08c2.73-2.1,6.42-2.47,9.51-.94l45.79,22.68c4.89,2.42,6.53,8.6,3.48,13.13l-42.47,63.02c-2.85,4.22-8.62,5.26-12.75,2.28l-59.25-42.62c-4.91-3.53-5.02-10.79-.24-14.48Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st22"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1411.21,
    cy: 498.47,
    r: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1426.59,
    cy: 485.54,
    r: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1426.36,
    cy: 511.34,
    r: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1441.58,
    cy: 497.99,
    r: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1454.75,
    cy: 483.59,
    r: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1470.61,
    cy: 468.4,
    r: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1485.15,
    cy: 476.36,
    r: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1469.81,
    cy: 492.83,
    r: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1457.77,
    cy: 509.16,
    r: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1447.48,
    cy: 524.4,
    r: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1486.83,
    cy: 502.79,
    r: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1500.59,
    cy: 485.08,
    r: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1440.34,
    cy: 473.27,
    r: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1455.82,
    cy: 459.85,
    r: 2.4
  }))))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    id: "left_hand6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1542.98,554.18c-16.07-16.11-77.21-73.47-87.82-24.39,0,0-27.19-1.33-18.98,25.74,0,0-19.2,2.79-17.17,16.4,1.1,7.43,8,12.44,15.24,11.5l8.38-1.09s23.72,2.54,28.61,17c0,0,.1,1.29.57,3.5,5.57,26.16,33.65,40.56,57.05,28.87,5.75-2.87,10.98-6.93,15.31-12.1,12.41-14.81,14.99-35.84,7.17-53.42-2.01-4.52-4.9-8.55-8.36-12.02Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1456.4,530s14.41,1.13,27.48,23.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1438,556.54s18.18,1.34,31.19,17.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1479.5,557.53s4.84-2.16,7.81-8.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1465.91,577.6s3.88-2.76,7.42-7.57"
  }))))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    id: "hair_6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M1444.4,400.3c3.67,4.11,9.81,5.28,14.53,2.43,1.4-.85,2.72-2.04,3.73-3.7,4.02-6.58.98-13.34.74-13.84,1.96,2,9.52,9.21,21.27,9.88,17.46.99,28.08-13.37,28.82-14.4.15,1.05,2.13,13.58,13.92,19.36,10.75,5.27,20.89.64,22.15.04-4.46,7.47-4.24,16.7.55,23.41,5.88,8.25,15.73,8.62,16.85,8.64-1.57,1.02-5.88,4.13-8.06,10.02-.12.32-.23.65-.33.97-2.47,7.88,1.82,16.28,9.45,19.43,14.35,5.93,30.25,4.16,40.77-4.49,16.46-13.53,18.62-42.96-.25-62.24,12.48-16.08,11.65-38.43-1.09-52.37-10.88-11.91-28.77-15.83-44.67-9.6-.8-1.99-5.44-13.05-17.51-17.64-10.86-4.13-23.49-1.42-32.58,6.91-8.79-7.42-20.78-9.54-31-5.36-12.21,4.99-19.86,18.14-18.29,32.11-11.41,2.03-20.88,9.79-24.55,20.34-3.7,10.63-1.89,21.77,5.55,30.1Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1512.39,364.2s-2.68,7.63.72,15.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1549.56,400.07s5.36-.73,11.72-7.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1566.96,432.12s6.62.54,11.77-.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M1583.41,358.65c3.1.95,4.98,4.23,5.43,7.44s-.22,6.46-.53,9.69c-.12,1.25-.19,2.54.23,3.73s1.44,2.23,2.69,2.33c1.9.14,3.3-1.91,3.49-3.81.19-1.9-.38-3.81-.27-5.71.04-.7.29-1.54.97-1.72.73-.2,1.39.5,1.67,1.2s.41,1.5.95,2.02c.93.89,2.63.34,3.23-.79.6-1.13.34-2.55-.21-3.71s-1.36-2.18-1.91-3.34-.82-2.56-.23-3.71c.76-1.49,2.72-2.07,3.46-3.56.89-1.78-.33-3.88-1.74-5.29-1.79-1.8-3.96-3.23-6.33-4.15-.62-.24-1.31-.45-1.94-.22-.95.34-1.31,1.54-1.12,2.53s.76,1.85,1.15,2.78.59,2.05.05,2.9c-1.53-.24-2.78-1.33-3.81-2.49s-1.97-2.44-3.27-3.28-3.12-1.14-4.36-.21c-1.27.95-1.47,2.88-.81,4.32s1.99,2.46,3.35,3.27"
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "st88",
    cx: 1634.45,
    cy: 334.72,
    r: 20.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st88",
    cx: 1508.64,
    cy: 288.45,
    r: 18.85
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    id: "shoes_5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M1099.23,1172.09l-52.68-15.42c-11.03-3.23-23.06-1.33-32.21,5.61-6.79,5.16-12.45,13.11-11.78,25.24.45,8.23,3.72,16.04,8.88,22.46,14.67,18.25,60.38,68.93,121.67,77.45,19.5,2.71,38.84-7.27,47.33-25.04.26-.55.52-1.1.76-1.67,6.2-14.2,4.57-27.03,3.65-32.08,4.74-21.99-4.36-44.74-22.89-57.28-18.9-12.8-43.98-12.52-62.73.73"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1013.13,1189.15s51.43,72.52,124.73,87.27c0,0,13.41-25.44,31.78-7.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M1047.88,1148.1l-3.85,7.57c-6.52,12.81-.59,28.5,12.82,33.69.23.09.45.17.68.26,13.92,5.28,29.25-3.35,32.24-17.94l1.92-9.36-43.81-14.21Z"
  }))))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    id: "face_7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st13",
    cx: 1294.57,
    cy: 323.65,
    rx: 52.12,
    ry: 58.59
  }), /*#__PURE__*/React.createElement("g", {
    className: "st28"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 1260.51,
    cy: 319.76,
    r: 4.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 1301.96,
    cy: 328.95,
    r: 4.12
  }))))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    id: "hair7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1248.07,297.13s11.59-22.54,26.04-26.64c-2.43.69,8.67,13.53,15.38,14.59,10.51,4.58,19.95,1.75,22.22,1.01.09.68,2.26,15.46,15.15,20.76,7.59,3.12,15.71,1.91,17.95,1.19,5.93,4.68,10.74,8.63,16.67,13.31,24.11-13.88,31.39-44.51,18.18-65.64-11.48-18.36-36.4-26.31-58.43-17.13-15.96-14.08-38.39-17.06-55.48-7.8-21.06,11.41-28.7,41.57-17.68,66.36Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M1356.89,256.05c-.67-.97-1.42-2.01-2.54-2.39s-2.65.32-2.63,1.5c.02.75.61,1.35,1.14,1.89,1.16,1.21,2.14,2.59,2.88,4.09.21.43.41.9.31,1.36-.19.9-1.4,1.22-2.25.88s-1.45-1.1-2.11-1.74-1.53-1.22-2.43-1.04c-1.01.19-1.64,1.31-1.61,2.33s.54,1.98,1.09,2.85c1.68,2.66,3.79,5.02,5.89,7.37.63.7,1.29,1.43,2.18,1.75s2.05.07,2.44-.79c.35-.76-.03-1.65-.5-2.34s-1.06-1.35-1.2-2.17.47-1.83,1.29-1.71c.65.1,1.05.83,1.68,1,.99.27,1.8-1,1.62-2-.18-1.01-.92-1.81-1.4-2.71s-.66-2.17.12-2.83c-.31.63.55,1.35,1.2,1.1s.91-1.09.75-1.76-.64-1.23-1.11-1.75c-2.34-2.6-5.12-5.24-8.6-5.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M1357.75,255.55c-1.28-1.74-3.27-3.95-5.66-2.58-2.29,1.31-1.09,3.26.05,4.8.78,1.06,3.06,2.47,1.18,2.98-1.52.42-.99-.42-2.27-.79-1.09-.32-1.77-.48-2.75.02-2.34,1.17-1.71,4.03-.71,5.87,1.08,1.98,10.71,15.32,12.64,8.27.31-1.12-1.5-4.53-1.06-4.88-.28.22,2.3.62,2.74.35,3.39-2-1.47-5.6-.2-7.72l-1.86-.5c.12,2.49,3.17,2.86,3.88.38,1.24-4.32-7.1-8.74-10.38-9.31-1.26-.22-1.8,1.71-.53,1.93,2.42.42,8.87,3.65,9.03,7-.05-.97-1.34-1.38-1.86-.5-.93,1.56-.38,2.23-.12,3.84.74.8.85,1.74.32,2.82-.34-.23-.71-.42-1.09-.57-.39.15-.78-.03-1.26.2-.91.44-1.35,1.48-1.29,2.47.04.71.98,1.57.97,2.16-.04,2.97-3.49-.74-4.28-1.68-1.29-1.53-2.64-3.07-3.65-4.81-2.25-3.88,2.19-1.4,3.7-1.03,1.02.25,2.09.45,2.99-.33,1.01-.88.78-1.93.43-3.04-.27-.83-.89-1.69-1.39-2.4-.3-.4-.61-.8-.92-1.2-1.52-1.28-.98-1.52,1.63-.73.75,1.03,2.49.03,1.73-1.01h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1273.61,269.99s-1.31-3.36-1.31-9.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1312.93,285.66s3.73-.84,7.68-5.92"
  }))))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    id: "left_eyebrow7"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1269.8,
    cy: 297.73,
    rx: 4.07,
    ry: 7.34,
    transform: "translate(841.97 1529.8) rotate(-84.05)"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    id: "nose_7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1284.49,310.53s-9.68,9.97-4.35,15.31"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    id: "mouth7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1267.38,327.2s7.66,6.51,24.27,3.94c-1.68,13.08-10.39,20.72-15.65,19.87-5.27-.85-11.15-10.84-8.61-23.81Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M1275.37,343.75c2.56-.09,5.13,1.09,6.74,3.08,1.01,1.25,1.64,3.01.96,4.47-.69,1.47-2.44,2.11-4.05,2.31-2.83.35-5.78-.21-8.28-1.59-.86-.47-1.69-1.06-2.2-1.89-2.15-3.48,4.2-6.28,6.83-6.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M1269.8,327.78h0c-.14,2.59,1.42,4.99,3.87,5.85s5.48,1.62,8.7,1.59c2.7-.02,5.04-1.86,5.68-4.48v-.06s-18.25-2.9-18.25-2.9Z"
  }))))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    id: "smores7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M1225.09,414.27c5.33,1.39,11.04,1.66,16.32.12,8.76-2.55,15.35-9.6,21.48-16.35,5.65-6.22,11.3-12.44,16.94-18.66,1.56-1.72,3.15-3.48,4.13-5.6s1.26-4.68.18-6.74c-1.08-2.06-3.77-3.32-5.88-2.34-1.45.68-2.32,2.17-3.12,3.56-5.46,9.5-12.12,18.31-19.77,26.16-4.07,4.18-8.61,8.2-14.17,9.94-7.79,2.45-16.2.07-23.97-2.44-1.5-.48-3.04-.98-4.62-.91s-3.22.84-3.89,2.27c-1.5,3.22,2.96,5.26,5.06,6.38,3.59,1.92,7.35,3.56,11.3,4.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M1260.3,395.52c.96-.92,2.04-1.75,2.81-2.84,2.42-3.45,1.09-8.62,3.68-11.94,1.53-1.96,4.09-2.83,5.8-4.63,1.31-1.38,2.02-3.22,2.51-5.05s.77-3.73,1.38-5.53c.61-1.8,1.58-3.55,3.14-4.64s3.78-1.37,5.35-.31c1.58,1.06,2.06,3.6.71,4.93-1.4,1.38-4.1,1.18-4.94,2.96-.83,1.76.99,3.97.13,5.72-.94,1.92-4.37,1.73-4.91,3.8-.33,1.26.7,2.42,1.48,3.46s1.27,2.75.19,3.49c-1.02.7-2.36-.2-3.27-1.04s-2.32-1.68-3.28-.9c-.98.8-.39,2.39.36,3.42s1.62,2.36.95,3.44c-.91,1.48-3.67.66-4.56,2.16-.57.97.07,2.16.62,3.14.55.98.95,2.37.1,3.09-.79.66-1.96.2-2.93-.15s-2.38-.34-2.66.65c-.43,1.5,1.81,2.38.97,4.07-.63,1.28-2.55,1.58-3.73.96-3.25-1.71-1.95-6.31.11-8.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1192.56,387.7c-.49,2.63.48,5.49,2.48,7.28,1.77,1.59,4.15,2.29,6.44,2.94,1.74.49,3.47.99,5.21,1.48.73.21,1.48.42,2.24.41,2.06-.01,3.87-1.69,4.47-3.67s.17-4.14-.7-6.01c-3.04-6.51-18.17-13.02-20.14-2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1213.85,403.13c1.89,2.02,4.54,3.22,7.25,3.77s5.51.5,8.28.32c1.43-.09,2.96-.25,4.07-1.15,1.82-1.46,1.82-4.27,1.03-6.47-2.59-7.27-9.32-8.21-16.03-8.89-7.07-.72-9,7.72-4.6,12.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1244.56,407.71c2.31-.63,4.38-1.97,6.17-3.56,1.05-.94,2.05-2.05,2.4-3.42,2.2-8.76-12.68-6.13-16.78-4.01-2.66,1.38-3.12,4.37-1.92,7.04,1.72,3.85,6.35,5,10.14,3.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1259.83,384.58c-.02,1.65.91,3.42,2.5,3.88,1.13.33,2.36-.06,3.31-.74s1.67-1.64,2.37-2.58c2.64-3.57,5.17-7.22,7.58-10.95.75-1.16,1.53-2.46,1.35-3.84-.82-6.39-8.62-1.12-10.4,1.58-2.31,3.49-6.66,8.34-6.71,12.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1273.56,358.03c-.5,3.81-.09,3.44-.58,6.79-.21,1.44-.12,3.15,1.06,4.02.86.64,2.08.6,3.07.18s1.8-1.16,2.58-1.89c1.05-.98,2.13-1.97,2.85-3.21.72-1.24,1.05-2.79.53-4.13-.65-1.66-2.49-2.62-4.27-2.75s-3.54.42-5.23.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M1199.71,389.75c2.2-.72,4.85.34,5.94,2.39.58,1.09.74,2.35,1.14,3.51s1.16,2.35,2.35,2.66c1.79.46,3.73-1.2,5.41-.45,1.6.71,2.07,3.27,3.82,3.41,1.68.13,2.54-2.15,4.14-2.67,1.61-.53,3.19.89,4.05,2.34s1.52,3.19,3.02,3.98c2,1.06,4.45-.1,6.26-1.47s3.67-3.04,5.93-3.05c2.76-.02,4.97,2.58,5.49,5.28s-.23,5.48-.98,8.14c-.13,1.04-1.61,1.43-2.5.88s-1.28-1.64-1.5-2.67-.33-2.11-.9-2.99-1.8-1.45-2.69-.89c-1.5.94-.86,4.06-2.61,4.29-1.55.21-2.06-2.36-3.58-2.71-1.54-.35-2.59,1.74-4.15,1.97-1.42.21-2.51-1.16-3.41-2.29s-2.42-2.25-3.63-1.48c-1.2.75-1.03,2.77-2.25,3.49-1.02.61-2.4-.15-2.96-1.2s-.59-2.29-.83-3.46-.82-2.42-1.95-2.8c-1.4-.48-2.83.59-3.88,1.63s-2.29,2.23-3.76,2.04c-1.34-.17-2.27-1.49-2.59-2.8s-.22-2.69-.43-4.03-.85-2.74-2.11-3.26c-1.71-.7-5.21.19-5.04-2.73.1-1.89,2.47-4.5,4.17-5.06Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M1187.07,376.84l32.86-41.13c1.82-2.27,4.94-3.23,7.82-2.39l48.92,14.16c4.52,1.31,6.49,6.33,3.95,10.11l-28.11,41.84c-1.71,2.55-5,3.72-8.07,2.87l-53.66-14.87c-4.81-1.33-6.72-6.8-3.7-10.58Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st68"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1202.63,
    cy: 377.45,
    r: 2.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1217.77,
    cy: 382.4,
    r: 2.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1231.7,
    cy: 386.49,
    r: 2.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1246.62,
    cy: 390.96,
    r: 2.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1254.65,
    cy: 377.95,
    r: 2.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1261.92,
    cy: 366.46,
    r: 2.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1268.87,
    cy: 354.93,
    r: 2.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1238.29,
    cy: 372.76,
    r: 2.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1246.62,
    cy: 359.92,
    r: 2.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1252.66,
    cy: 348.99,
    r: 2.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1223.25,
    cy: 369.33,
    r: 2.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1231.59,
    cy: 356.1,
    r: 2.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1238.14,
    cy: 343.56,
    r: 2.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1210.51,
    cy: 363.17,
    r: 2.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1217.77,
    cy: 350.29,
    r: 2.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1225.34,
    cy: 339.68,
    r: 2.09
  }))))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    id: "hand_7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1329.33,431.65s-69.55-90.49-85.72-21.34c0,0-25.38-.62-15.53,29.17,0,0-41.7,12.04,24.29,39.67,1.28.54,2.08,1.82,2.01,3.21,0,.05,0,.11,0,.16-.66,14.49,8.51,27.66,22.26,32.29,19.6,6.6,41.92,1.19,55.37-14.63,16.34-19.21,15.66-49.13-2.67-68.53Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1244.72,410.53s31.69,5.52,39.77,30.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1229.36,439.48s22.42-1.25,35.94,22.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1280.58,443.59s4.11-1.38,7.49-5.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1262.11,463.79s3.4-.15,6.91-4.82"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1350.95,395.81s-11.49,16.13-5.74,40.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1332.66,435.54s18.38,1.6,39.24,18.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1259.14,504.83s9.28,28.96,25.35,45.03"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 1215.68,
    y1: 471.35,
    x2: 1224.53,
    y2: 498.89
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    id: "left_hand_7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1132.67,410.31s-4-20.96.84-42.31c5.34-23.55,25.1-41.41,49.18-43.18,10.34-.76,21.64,1.5,29.99,11.46,2.17,2.59,3.35,5.95,2.92,9.31s-2.49,7.43-8.92,9.47c0,0,1.62,12.04-8.53,13.65,0,0,3.04,8.04-7.67,9.32,0,0,1.93,12.81,21.34,14.73,0,0,8.45,38.35-29.35,50.83,0,0-37.93,8.55-49.79-33.28Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1205.86,353.79s-9.28-16.87-28.93-9.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1197.2,368.16s-9.2-12.41-25.71-4.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1189.38,378.04s-5.66.38-12.45-3.14c0,0-3.37,3.29-1.99,9.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1170.76,359.76s-1.17,3.5.85,6.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1175.89,341.01s-1.79,3.59,1.8,7.18"
  }))))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    id: "right_eyebrow"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1307.4,
    cy: 307.54,
    rx: 3.98,
    ry: 7.29,
    transform: "translate(516.15 1392.81) rotate(-67.14)"
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    id: "ear_7"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 1349.42,
    cy: 322.21,
    r: 15.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1343.69,316.4c.33-.2,4.47-2.62,9.01-.53,4.73,2.18,5.46,7.22,5.5,7.53"
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    id: "left_wye"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1262.76,308.16c1.1-2,3.37-3.05,5.55-2.59,2.06.43,3.66,2.13,3.99,4.24"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    id: "right_eye7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1300.04,317.09c1.38-1.88,3.88-2.57,5.95-1.69,1.85.79,3.02,2.7,2.89,4.75"
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    id: "lower_leg5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M1099.23,1172.09s21.21-176.51,121.26-176.51,0,0,0,0c0,0,73.5,1.7,44.46,103.59,0,0-19.91,60.66-80.1,129.48,0,0-59.41-11.16-85.62-56.56Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st44"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M1173.53,1058.81s-37.62,26.33-62.25,139.9l15.27,13.56s22.4-103.76,57.22-132.93.78,1.35.78,1.35c0,0,13.54-19.19-10.76-22.43"
  }))))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    id: "leftleg_5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M1557.17,1046.91s45.13,78.22-43.82,138.89c0,0-121.77,82.52-264.26-40.19,0,0-139.96-107.94-56.96-145.59,0,0,90.57-29.52,365.04,46.89Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M1439.65,1085.66s-22.46,51.99-117.11,10.04c-15.37-6.81-29.9-15.37-43.57-25.16-20.65-14.79-69.06-41.86-110.66-7.58l7.69,20.02s44.31-27.33,99.45,14.97c7.49,5.75,15.37,10.98,23.75,15.35,34.22,17.85,111.81,47.42,162.96-16.98l-22.5-10.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1387.26,1117.18s-27.21,25.64,2.06,54.91"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1244.86,1142.99s-13.75-12.6-24.3-30.87"
  }))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    id: "body_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1407.34,834.55c11.5-10.31,25.36-17.75,40.42-21.14,27.09-6.1,65.97-1.46,96.61,55.91,0,0,90.37,168.58-29.36,230.33,0,0-100.7,46.56-153.78-62.79-5.95-2.86-37.25-18.65-47.44-53.56-10.46-35.82,5.58-77.1,40.68-101.31,17.62-15.81,35.25-31.62,52.87-47.43Z"
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    id: "left_upper_hand"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1401.85,838.68c34.72-10.45,71.38,5.5,86.23,35.92,12.9,26.43,7.19,59.42-14.61,81.56-9.98,15.59-29.51,37.63-59.11,57.09-37.59,24.72-91.26,41.8-155.55,11.21,0,0-24.35-9.55-41.92-38.39-17.34-28.47-7.48-65.77,22.01-81.31.22-.12.45-.24.68-.35,18.02-9.3,35.57-10.77,48.43-10.02,10.87.63,20.59,6.99,25.45,16.73h0s88.39-72.44,88.39-72.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1361.23,1036.86s26.17-2.06,46.51-25.32"
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    id: "left_lower_hand"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1199.73,944.06c-1.47-10.44-1.71-22.89.36-37.43,2.66-18.71,14.85-34.93,32.49-41.7,3.79-1.45,7.77-2.47,11.88-3.01,25.87-3.36,43.37,14.33,45.2,16.24,3.01,2.52,6.27,5.43,9.27,9.08,2.34,2.84,4.95,6.43,7.58,10.85,10.52,17.68,12.98,39.19,5.69,58.42-3.2,8.45-8.46,17.09-16.96,24.43-.53.46-1.06.9-1.6,1.34-35.1,28.3-87.63,6.42-93.91-38.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1201.77,912.52s27.04,28.57,55.71,15.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1313.46,911.12s4.89,14.63,0,31.07"
  }))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    id: "face5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 1400.2,
    cy: 777.03,
    r: 67.71
  }), /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st106",
    cx: 1383.81,
    cy: 782.72,
    r: 6.27
  }))))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    id: "eyebrow5"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1360.2,
    cy: 756.08,
    rx: 4.78,
    ry: 7.77,
    transform: "translate(320.7 1914.19) rotate(-77.16)"
  }))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    id: "eye5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1351.41,768.11c1.4-2.38,4.24-3.49,6.82-2.71,2.71.82,4.48,3.55,4.12,6.43"
  }))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    id: "nose5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1343.49,769.98s-8.51,12.97,0,17.88"
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    id: "mouth5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1339.59,797.46c2.45,13.88,10.9,21.53,16.05,20.51,4.45-.89,8.16-8.59,8.4-18.17-8.15-.78-16.29-1.56-24.44-2.34Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M1348.65,810.71c2.64-1.26,5.91-1.28,8.42.23,2.51,1.5,4.06,4.59,3.49,7.45-.61,3.05-3.47,5.34-6.54,5.82s-6.24-.64-8.74-2.49c-4.98-3.68-1.09-8.88,3.37-11.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M1342.51,795.89l.33,1.63c.57,2.86,2.92,5.02,5.82,5.36l5.5.64c3.51.41,6.73-1.97,7.38-5.44h0s-19.03-2.18-19.03-2.18Z"
  }))))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    id: "smores5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M1300.48,870.81c13.48-5.64,26.66-11.99,39.47-19,5.96-3.26,12.07-6.88,15.78-12.57,1.83-2.8,2.87-6.81.64-9.3-1.39-1.55-3.71-1.99-5.76-1.64s-3.92,1.38-5.75,2.4c-9.19,5.11-18.39,10.21-27.58,15.32-7.32,4.06-14.77,8.25-20.8,14.14-1.93,1.88-6.78,5.98-6.42,9.02.58,4.93,7.75,2.75,10.43,1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M1331.91,842.07c3.98-2.06,8.12-3.82,12.37-5.26,1.84-.62,3.83-1.19,5.69-.65,2.04.59,3.52,2.42,4.31,4.4.62,1.55.87,3.34.21,4.86-.67,1.53-2.47,2.62-4.05,2.07-1.49-.52-2.21-2.14-3.2-3.36-.99-1.22-3.06-2.03-4.01-.78-.69.91-.22,2.2.14,3.28.36,1.09.41,2.59-.64,3.05-2.02.9-2.98-3.51-5.19-3.37-1.13.07-1.78,1.37-1.8,2.5s.36,2.26.23,3.38c-.13,1.12-1.11,2.3-2.21,2.02-1.42-.36-1.45-2.58-2.75-3.27-1.35-.72-2.93.87-3.02,2.4s.68,2.97.95,4.47c.27,1.51-.25,3.44-1.75,3.76-2.69.58-3.95-4.43-6.69-4.12-2.02.23-2.42,2.99-2.19,5.01s.11,4.73-1.86,5.25c-1.96.52-3.41-1.76-4.23-3.62-.64-1.46-2.16-3.79-4.08-3.27-2.05.55-1.64,3.08-2.18,4.63-.7,2.04-5.45,5.72-6.59,2.24-.76-2.31,3.4-6.24,4.76-7.56,3.46-3.36,7.9-5.75,11.9-8.39,5.17-3.41,10.35-6.83,15.86-9.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M1300.04,861.22c2.21,1.37,4.99,1.57,7.53,1.03s4.89-1.75,7.13-3.06c2.51-1.46,5.01-3.15,6.51-5.64,1.5-2.48,1.72-5.96-.22-8.12-1.26-1.41-3.24-2.04-5.13-2.02s-3.74.63-5.49,1.36c-5.12,2.15-20.11,10.37-10.33,16.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M1318.22,844.09c-.17,2.17.84,4.51,2.77,5.52,2.75,1.44,6.05-.1,8.73-1.66,2.44-1.42,4.85-2.88,7.24-4.38,2.52-1.58,5.32-3.76,5.17-6.73-.52-10.93-23.28-.9-23.92,7.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M1340.33,836.75c1.42,1.76,4.13,2.01,6.25,1.19,2.11-.83,3.77-2.49,5.35-4.12,1.15-1.19,2.37-2.53,2.49-4.18.35-4.7-6.69-6.14-9.85-4.08s-6.97,7.79-4.23,11.19Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M1266.19,815.56l64.68-13.88c2.21-.47,4.52-.06,6.42,1.16l14.33,9.17c5.39,3.45,5.25,11.37-.27,14.62l-60.63,35.7c-4.07,2.4-9.32,1.05-11.73-3.01l-18.38-30.98c-2.99-5.04-.16-11.53,5.58-12.76Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st30"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1279.04,
    cy: 821.94,
    r: 2.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1296.79,
    cy: 816,
    r: 2.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1312.7,
    cy: 811.37,
    r: 2.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1328.11,
    cy: 806.75,
    r: 2.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1338.93,
    cy: 813.44,
    r: 2.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1324.45,
    cy: 821.27,
    r: 2.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1305.43,
    cy: 827.38,
    r: 2.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1285.22,
    cy: 835.48,
    r: 2.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1316.14,
    cy: 838.39,
    r: 2.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1334.55,
    cy: 830.26,
    r: 2.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 1348.98,
    cy: 822.66,
    r: 2.07
  }))))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    id: "left_hand5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1201.88,892.4s-6.59-96.19,84.51-117.84c0,0,43.04-.37-20.72,53.78,0,0-.33,21.58,26.93,14.58,0,0,35.06-2.76-2.94,35.25-2.15,20.43-17.52,37.06-37.47,40.72-20.62,3.78-41.51-7.15-50.3-26.49Z"
  }))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    id: "hair5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1343.49,739.71c-6.73-11.87-5.93-27.16,1.86-37.71,7.17-9.7,19.04-13.75,30.12-10.24,2.03-19.68,16.19-33.7,30.97-33.44,10.81.19,20.96,7.99,26.39,19.75,13.98-14.36,34.47-16.75,49.61-6.39,17.42,11.91,24.31,38.34,14.5,60.51,24.2,25.33,23.62,63.48,8.55,79.73-10.06,10.85-28.56,14.08-46.06,6.93-15.68-6.41-26.16-22.77-27.72-41.32-.37-4.41-1.22-9.32-2.89-14.5-3.85-11.96-10.21-19.62-13.74-23.31-2.81,5.63-8.4,8.68-13.78,7.64-6.21-1.2-10.96-7.62-10.86-15.17-.47.48-6.07,6.1-13.39,4.14-5.2-1.39-7.94-5.7-8.6-6.81-.75,1.69-3.39,7.07-9.23,10.06-7.56,3.86-14.57.69-15.73.14Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1468.96,681.99c-2.74-2.11-6.78-2.36-9.76-.61-1.19.7-2.31,2.08-1.75,3.34.41.91,1.49,1.27,2.44,1.58,2.06.67,4.06,1.54,5.95,2.6,1.01.57,2.11,1.38,2.12,2.54.02,1.34-1.5,2.24-2.84,2.18s-2.55-.75-3.8-1.21-2.78-.66-3.83.16c-1.15.89-1.24,2.67-.59,3.97s1.84,2.23,3.01,3.08c3.9,2.86,8.47,5.64,13.24,4.85,1.24-.2,2.48-.68,3.37-1.57.89-.89,1.36-2.26.96-3.45-.4-1.2-1.52-1.98-2.27-3s-.95-2.74.17-3.31c1-.51,2.28.31,3.29-.15.81-.36,1.09-1.42.87-2.28s-.82-1.55-1.4-2.22c-1.84-2.11-3.71-4.23-5.97-5.87-2.26-1.64-5-2.79-7.79-2.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1469.72,680.7c-3.67-2.32-9.89-3.14-12.92.83-4.11,5.38,4.51,5.88,6.85,7.92l1.44.76c-.16,1.79-.87,2.21-2.11,1.27-1.17-.01-2.33-.95-3.63-.91-1.58.05-2.98.62-3.81,2.06-2.56,4.43,3.29,8.27,6.31,10.15,4.14,2.58,10.46,5.14,14.93,1.81,1.26-.94,2.23-2.26,2.32-3.9.12-2.04-2.94-4.41-1.51-6.06.81-.94,2.36-.13,3.16-1.8.75-1.56.17-3.02-.71-4.36-3.5-5.3-9.21-9.73-15.66-10.02-1.93-.09-1.93,2.91,0,3,3.79.17,6.57,1.88,9.28,4.41.87.81,4.92,4.26,3.93,5.77-.51.78-3.36-.37-4.26,1.74-.73,1.71.37,2.7.82,4.16,1.43,1.2,1.64,2.82.62,4.85-1.93.84-3.9.97-5.91.39-2.04-.5-5.33-1.91-6.87-3.48-2.13-.96-2.48-2.77-1.06-5.42.82.35,1.66.67,2.5.97,1.03.23,2.07.43,3.11.11,1.43-.44,2.69-1.55,2.87-3.1.24-2.03-1.31-3.23-2.81-4.23-1.48-.99-3.22-1.4-4.77-2.21-2.8-.47-2.27-1.69,1.61-3.67,1.77-.03,3.36.49,4.77,1.56,1.64,1.03,3.14-1.56,1.51-2.59h0Z"
  })))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1514.65,
    cy: 649.65,
    rx: 29.19,
    ry: 19.56,
    transform: "translate(-91.39 1019.58) rotate(-36.19)"
  }))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    id: "collar5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1414.91,814.57c7.68-1.45,15.67-2.25,22.57-5.9,8.68-4.59,14.49-13.03,20.9-20.46,6.41-7.43,14.71-14.51,24.53-14.58,10.37-.08,19.64,8.43,22.17,18.49,2.54,10.06-.83,20.98-7.15,29.22-6.31,8.23-15.27,14.07-24.63,18.55-17.84,8.53-37.78,12.54-57.53,11.77-13.41-.53-31.17-3.93-24.78-21.95,3.49-9.83,14.62-13.39,23.91-15.14Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1423.74,811.49c1.13,4,4.92,6.86,8.97,7.78s8.31.19,12.26-1.09c14.88-4.81,26.86-17.73,30.54-32.93,1.1-4.55,1.37-9.77-1.44-13.51s-9.65-4.33-11.74-.14"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1497.94,821.34s-20.06,24.89-69.84,24.89"
  }))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    id: "ear5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 1441.52,
    cy: 778.47,
    r: 13.89,
    transform: "translate(442.19 2076.68) rotate(-80.78)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1438.48,771.95c.4-.18,3.82-1.62,7.27.25,3.99,2.17,4.25,6.73,4.26,6.96"
  }))))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    id: "logs"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M749.69,853.09l69.7-28.1c17.03-6.86,36.32,2.01,42.19,19.4h0c4.79,14.16-.9,29.75-13.67,37.51l-76.88,46.7-21.35-75.51Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 758.58,
    cy: 890.72,
    r: 39.88
  }), /*#__PURE__*/React.createElement("g", {
    className: "st82"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M730.93,893.27c.21,2.18,1.23,10.26,8.06,16.95,6.33,6.19,13.69,7.32,15.98,7.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M739.18,874.31c-.54.52-3.76,3.77-3.58,8.77.22,6.11,5.32,9.33,5.72,9.58"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M798.02,992.93l99.13-67.59c17.34-11.82,21.14-35.8,8.31-52.41h0c-11.36-14.71-31.96-18.51-47.83-8.84l-102.67,62.58,43.04,66.26Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 776.13,
    cy: 960.03,
    r: 39.51
  }), /*#__PURE__*/React.createElement("g", {
    className: "st83"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M749.69,961.75c.01,1.75.26,11.95,8.61,19.71,9.33,8.67,21.07,7.12,22.58,6.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M800.03,946.46c.89.99,4.95,5.74,4.7,12.87-.22,6.33-3.69,10.47-4.7,11.59"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 776.54,
    cy: 953.56,
    r: 6.48
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1120.17,850.37l-69.7-28.1c-17.03-6.86-36.32,2.01-42.19,19.4h0c-4.79,14.16.9,29.75,13.67,37.51l76.88,46.7,21.35-75.51Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1111.28,
    cy: 888,
    r: 39.88
  }), /*#__PURE__*/React.createElement("g", {
    className: "st84"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1102.7,865.41c1.28-.54,10.59-4.3,20.42.74,9.97,5.11,12.3,15.1,12.59,16.42"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1111.28,
    cy: 888,
    r: 5.92
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M1071.84,990.21l-99.13-67.59c-17.34-11.82-21.14-35.8-8.31-52.41h0c11.36-14.71,31.96-18.51,47.83-8.84l102.67,62.58-43.04,66.26Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1093.73,
    cy: 957.32,
    r: 39.51
  }), /*#__PURE__*/React.createElement("g", {
    className: "st85"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1074.27,973.98c1.07,1.39,7.15,9.05,18.19,10.39,11.12,1.35,18.9-4.72,20.25-5.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1100.56,940.35c3.93-1.56,8.42-.72,11.5,2.16,3.15,2.95,4.27,7.52,2.83,11.62"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M892.8,990.21l9.63-89.18c1.75-16.17,15.02-28.65,31.27-29.4h0c17.29-.8,32.25,11.91,34.27,29.1l11.39,97.01-86.56-7.53Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 935.75,
    cy: 997.74,
    r: 43.61
  }), /*#__PURE__*/React.createElement("g", {
    className: "st86"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M913.08,985.6s-.85-16.2,19.02-17.43"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 932.97,
    cy: 998.94,
    r: 5.73
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M964.27,980.71s10.95,19.72-6.36,37.04"
  }))))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    id: "plate"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st105",
    cx: 930.34,
    cy: 1091.75,
    rx: 149.46,
    ry: 67.47
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st101",
    cx: 928.55,
    cy: 1084.63,
    rx: 149.46,
    ry: 60.35
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M829.01,1065.59c5.62,2,11.88,2.36,17.99,2.39,26.19.15,52.4-5.18,75.55-15.35,4.1-1.8,8.37-3.99,10.18-7.54,2.71-5.32-2.53-12.24-9.49-12.52-25.74,7.14-53.56,11.98-80.78,12.31-6.28.08-17.71-3.2-22.75.98-8.18,6.78,1.44,16.93,9.3,19.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M828.17,1052.17c4.32,1.15,9.56-.28,13.24,1.93,2.85,1.71,3.56,4.89,4.87,7.6s4.48,5.48,7.81,4.53c3.26-.93,3.77-4.48,4.05-7.32s1.92-6.44,5.36-6.3c3.79.15,5.34,4.81,9.1,5.23,5.73.63,5.94-8.04,11.3-9.83,3.99-1.33,7.91,1.92,10.31,4.88s5.82,6.41,10.01,5.6c4.06-.79,5.4-5.05,5.18-8.51s-1.11-7.26,1.25-10.12c2.66-3.22,8.04-3.62,12.69-4.22s10.1-2.53,10.51-6.41c.39-3.68-4.5-6.51-8.96-6.43s-8.47,2.11-12.37,3.9c-17.49,8.01-37.51,12.09-57.47,11.93-7.65-.06-19.5-3.75-26.57-1.78-8.5,2.38-9.1,13-.31,15.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M820.69,1044.68c4.21,2.49,9.65,2.99,14.82,3.05,5.14.06,10.97-.51,14.08-3.9,8.67-9.44-11.11-19.73-20.44-20.89-14.3-1.79-19.28,15.34-8.46,21.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M863.62,1046.07c5.78,1.01,11.73-.35,17.41-1.7,3.74-.89,7.58-1.83,10.62-3.84,15.71-10.42-11.64-16.74-21.23-15.54-5.9.74-14.56,3.92-16.75,8.85-2.57,5.77,3.35,11.07,9.95,12.23Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M928.43,1012.93c-4.6-5.8-10.76-11.29-18.88-12.94-6.4-1.31-13.11-.06-19.52,1.19-22.01,4.28-44.02,8.56-66.02,12.84-6.18,1.2-10.43,6-9.79,11.24.55,4.46,2.47,8.04,9.39,9.35,11.28,2.14,25.29.62,36.61-.65,5.92-.66,71.53-16.85,68.21-21.04Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st79"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M824.95,1018.17c-.7.52-1.12,1.4-.72,2.12.24.43.75.74,1.3.87s1.14.11,1.71.01c.93-.16,1.83-.55,2.38-1.19s.66-1.56.13-2.21c-1.08-1.31-3.7-.41-4.8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M843.35,1014.5c-.68.54-1.06,1.39-.74,2.12.28.65,1.06,1.1,1.88,1.23s1.68-.03,2.44-.3c.74-.27,1.45-.67,1.81-1.27.42-.71.22-1.63-.46-2.18-1.26-1.01-3.77-.49-4.92.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M859.84,1013.53c.7.66,1.91.77,2.94.57.74-.14,1.45-.44,1.92-.93s.62-1.22.25-1.76c-1.48-2.2-7.55-.17-5.1,2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M874.3,1008.41c-.73.59-1.03,1.65-.35,2.29.62.59,1.73.57,2.66.41.97-.17,2-.52,2.45-1.25.61-1.01-.17-2.07-1.39-2.36-1.13-.28-2.55.25-3.37.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M888.09,1004.83c-.56.29-1.01.76-1.05,1.3-.05.77.79,1.43,1.7,1.56s1.84-.15,2.64-.54c.61-.3,1.23-.75,1.25-1.34.01-.52-.47-.98-1.04-1.19-1.12-.41-2.48-.32-3.51.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M900.35,1004.95c.49.27,1.14.24,1.73.19.91-.07,1.85-.15,2.61-.56,2.05-1.1.4-3.24-1.68-2.98-1.42.18-4.91,2.11-2.66,3.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M828.05,1030.16c.26.67,1.1,1.11,1.95,1.16s1.69-.23,2.39-.63c.65-.37,1.26-.93,1.27-1.59.05-2.84-6.78-1.97-5.6,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M844.58,1026.39c.41.87,1.71,1.22,2.82,1.11.82-.08,1.64-.35,2.2-.86,1.26-1.15.35-3.23-1.59-3.28-1.69-.04-4.16,1.47-3.43,3.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M861.21,1022.37c.3.9,1.52,1.38,2.64,1.39.9.01,1.82-.21,2.48-.72,1.39-1.08.75-3.31-1.24-3.5-1.73-.17-4.42,1.18-3.88,2.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M878.63,1016.59c-.62.53-.81,1.49-.16,1.99.46.36,1.16.38,1.79.33,1.03-.08,2.19-.38,2.58-1.18.46-.93-.4-1.79-1.49-1.97-.95-.16-2.06.25-2.72.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M893.43,1012.82c-.5.36-.97.85-.93,1.4.04.68.88,1.18,1.7,1.25s1.62-.18,2.39-.43c.77-.25,1.66-.61,1.79-1.29.16-.83-1.14-1.74-2.04-1.92-1.02-.21-2.18.47-2.91.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M909.48,1010.92c.63.4,1.52.28,2.29.15.55-.1,1.1-.2,1.59-.43,1.97-.96.18-3.05-1.64-2.97-1.55.07-4.03,2.11-2.23,3.25Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M933.7,1036.55c-3.32,3.72-4.68,9.69-1.74,13.72,1.81,2.46,4.9,3.75,7.95,3.93s6.07-.63,8.93-1.71c3.94-1.48,7.75-3.51,10.68-6.52,2.93-3.02,4.91-7.12,4.74-11.32s-2.76-8.38-6.71-9.82c-5.7-2.08-20.12,7.54-23.85,11.72Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M1018.92,1082.15c-5.62,2-11.88,2.36-17.99,2.39-26.19.15-52.4-5.18-75.55-15.35-4.1-1.8-8.37-3.99-10.18-7.54-2.71-5.32,2.53-12.24,9.49-12.52,25.74,7.14,53.56,11.98,80.78,12.31,6.28.08,17.71-3.2,22.75.98,8.18,6.78-1.44,16.93-9.3,19.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M1019.76,1068.73c-4.32,1.15-9.56-.28-13.24,1.93-2.85,1.71-3.56,4.89-4.87,7.6s-4.48,5.48-7.81,4.53c-3.26-.93-3.77-4.48-4.05-7.32-.27-2.85-1.92-6.44-5.36-6.3-3.79.15-5.34,4.81-9.1,5.23-5.73.63-5.94-8.04-11.3-9.83-3.99-1.33-7.91,1.92-10.31,4.88-2.4,2.96-5.82,6.41-10.01,5.6-4.06-.79-5.4-5.05-5.18-8.51s1.11-7.26-1.25-10.12c-2.66-3.22-8.04-3.62-12.69-4.22-4.65-.6-10.1-2.53-10.51-6.41-.39-3.68,4.5-6.51,8.96-6.43,4.46.08,8.47,2.11,12.37,3.9,17.49,8.01,37.51,12.09,57.47,11.93,7.65-.06,19.5-3.75,26.57-1.78,8.5,2.38,9.1,13,.31,15.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M1027.24,1061.25c-4.21,2.49-9.65,2.99-14.82,3.05-5.14.06-10.97-.51-14.08-3.9-8.67-9.44,11.11-19.73,20.44-20.89,14.3-1.79,19.28,15.34,8.46,21.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M984.31,1062.64c-5.78,1.01-11.73-.35-17.41-1.7-3.74-.89-7.58-1.83-10.62-3.84-15.71-10.42,11.64-16.74,21.23-15.54,5.9.74,14.56,3.92,16.75,8.85,2.57,5.77-3.35,11.07-9.95,12.23Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M919.5,1029.5c4.6-5.8,10.76-11.29,18.88-12.94,6.4-1.31,13.11-.06,19.52,1.19,22.01,4.28,44.02,8.56,66.02,12.84,6.18,1.2,10.43,6,9.79,11.24-.55,4.46-2.47,8.04-9.39,9.35-11.28,2.14-25.29.62-36.61-.65-5.92-.66-71.53-16.85-68.21-21.04Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st80"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1022.98,1034.74c.7.52,1.12,1.4.72,2.12-.24.43-.75.74-1.3.87s-1.14.11-1.71.01c-.93-.16-1.83-.55-2.38-1.19s-.66-1.56-.13-2.21c1.08-1.31,3.7-.41,4.8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1004.58,1031.07c.68.54,1.06,1.39.74,2.12-.28.65-1.06,1.1-1.88,1.23s-1.68-.03-2.44-.3c-.74-.27-1.45-.67-1.81-1.27-.42-.71-.22-1.63.46-2.18,1.26-1.01,3.77-.49,4.92.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M988.09,1030.1c-.7.66-1.91.77-2.94.57-.74-.14-1.45-.44-1.92-.93s-.62-1.22-.25-1.76c1.48-2.2,7.55-.17,5.1,2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M973.63,1024.98c.73.59,1.03,1.65.35,2.29-.62.59-1.73.57-2.66.41-.97-.17-2-.52-2.45-1.25-.61-1.01.17-2.07,1.39-2.36,1.13-.28,2.55.25,3.37.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M959.84,1021.4c.56.29,1.01.76,1.05,1.3.05.77-.79,1.43-1.7,1.56s-1.84-.15-2.64-.54c-.61-.3-1.23-.75-1.25-1.34-.01-.52.47-.98,1.04-1.19,1.12-.41,2.48-.32,3.51.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M947.58,1021.52c-.49.27-1.14.24-1.73.19-.91-.07-1.85-.15-2.61-.56-2.05-1.1-.4-3.24,1.68-2.98,1.42.18,4.91,2.11,2.66,3.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1019.88,1046.73c-.26.67-1.1,1.11-1.95,1.16s-1.69-.23-2.39-.63c-.65-.37-1.26-.93-1.27-1.59-.05-2.84,6.78-1.97,5.6,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1003.35,1042.96c-.41.87-1.71,1.22-2.82,1.11-.82-.08-1.64-.35-2.2-.86-1.26-1.15-.35-3.23,1.59-3.28,1.69-.04,4.16,1.47,3.43,3.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M986.72,1038.93c-.3.9-1.52,1.38-2.64,1.39-.9.01-1.82-.21-2.48-.72-1.39-1.08-.75-3.31,1.24-3.5,1.73-.17,4.42,1.18,3.88,2.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M969.3,1033.16c.62.53.81,1.49.16,1.99-.46.36-1.16.38-1.79.33-1.03-.08-2.19-.38-2.58-1.18-.46-.93.4-1.79,1.49-1.97.95-.16,2.06.25,2.72.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M954.5,1029.39c.5.36.97.85.93,1.4-.04.68-.88,1.18-1.7,1.25s-1.62-.18-2.39-.43c-.77-.25-1.66-.61-1.79-1.29-.16-.83,1.14-1.74,2.04-1.92,1.02-.21,2.18.47,2.91.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M938.45,1027.49c-.63.4-1.52.28-2.29.15-.55-.1-1.1-.2-1.59-.43-1.97-.96-.18-3.05,1.64-2.97,1.55.07,4.03,2.11,2.23,3.25Z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M873.84,1079.35c-3.32,3.72-4.68,9.69-1.74,13.72,1.81,2.46,4.9,3.75,7.95,3.93,3.05.18,6.07-.63,8.93-1.71,3.94-1.48,7.75-3.51,10.68-6.52s4.91-7.12,4.74-11.32-2.76-8.38-6.71-9.82c-5.7-2.08-20.12,7.54-23.85,11.72Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M959.06,1124.95c-5.62,2-11.88,2.36-17.99,2.39-26.19.15-52.4-5.18-75.55-15.35-4.1-1.8-8.37-3.99-10.18-7.54-2.71-5.32,2.53-12.24,9.49-12.52,25.74,7.14,53.56,11.98,80.78,12.31,6.28.08,17.71-3.2,22.75.98,8.18,6.78-1.44,16.93-9.3,19.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M959.9,1111.54c-4.32,1.15-9.56-.28-13.24,1.93-2.85,1.71-3.56,4.89-4.87,7.6s-4.48,5.48-7.81,4.53c-3.26-.93-3.77-4.48-4.05-7.32s-1.92-6.44-5.36-6.3c-3.79.15-5.34,4.81-9.1,5.23-5.73.63-5.94-8.04-11.3-9.83-3.99-1.33-7.91,1.92-10.31,4.88-2.4,2.96-5.82,6.41-10.01,5.6-4.06-.79-5.4-5.05-5.18-8.51s1.11-7.26-1.25-10.12c-2.66-3.22-8.04-3.62-12.69-4.22s-10.1-2.53-10.51-6.41c-.39-3.68,4.5-6.51,8.96-6.43,4.46.08,8.47,2.11,12.37,3.9,17.49,8.01,37.51,12.09,57.47,11.93,7.65-.06,19.5-3.75,26.57-1.78,8.5,2.38,9.1,13,.31,15.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M967.38,1104.05c-4.21,2.49-9.65,2.99-14.82,3.05-5.14.06-10.97-.51-14.08-3.9-8.67-9.44,11.11-19.73,20.44-20.89,14.3-1.79,19.28,15.34,8.46,21.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M924.45,1105.44c-5.78,1.01-11.73-.35-17.41-1.7-3.74-.89-7.58-1.83-10.62-3.84-15.71-10.42,11.64-16.74,21.23-15.54,5.9.74,14.56,3.92,16.75,8.85,2.57,5.77-3.35,11.07-9.95,12.23Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M859.64,1072.3c4.6-5.8,10.76-11.29,18.88-12.94,6.4-1.31,13.11-.06,19.52,1.19,22.01,4.28,44.02,8.56,66.02,12.84,6.18,1.2,10.43,6,9.79,11.24-.55,4.46-2.47,8.04-9.39,9.35-11.28,2.14-25.29.62-36.61-.65-5.92-.66-71.53-16.85-68.21-21.04Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st81"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M963.12,1077.54c.7.52,1.12,1.4.72,2.12-.24.43-.75.74-1.3.87s-1.14.11-1.71.01c-.93-.16-1.83-.55-2.38-1.19s-.66-1.56-.13-2.21c1.08-1.31,3.7-.41,4.8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M944.72,1073.87c.68.54,1.06,1.39.74,2.12-.28.65-1.06,1.1-1.88,1.23s-1.68-.03-2.44-.3c-.74-.27-1.45-.67-1.81-1.27-.42-.71-.22-1.63.46-2.18,1.26-1.01,3.77-.49,4.92.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M928.23,1072.9c-.7.66-1.91.77-2.94.57-.74-.14-1.45-.44-1.92-.93s-.62-1.22-.25-1.76c1.48-2.2,7.55-.17,5.1,2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M913.77,1067.78c.73.59,1.03,1.65.35,2.29-.62.59-1.73.57-2.66.41-.97-.17-2-.52-2.45-1.25-.61-1.01.17-2.07,1.39-2.36,1.13-.28,2.55.25,3.37.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M899.98,1064.2c.56.29,1.01.76,1.05,1.3.05.77-.79,1.43-1.7,1.56s-1.84-.15-2.64-.54c-.61-.3-1.23-.75-1.25-1.34-.01-.52.47-.98,1.04-1.19,1.12-.41,2.48-.32,3.51.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M887.72,1064.32c-.49.27-1.14.24-1.73.19-.91-.07-1.85-.15-2.61-.56-2.05-1.1-.4-3.24,1.68-2.98,1.42.18,4.91,2.11,2.66,3.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M960.02,1089.53c-.26.67-1.1,1.11-1.95,1.16s-1.69-.23-2.39-.63c-.65-.37-1.26-.93-1.27-1.59-.05-2.84,6.78-1.97,5.6,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M943.49,1085.76c-.41.87-1.71,1.22-2.82,1.11-.82-.08-1.64-.35-2.2-.86-1.26-1.15-.35-3.23,1.59-3.28,1.69-.04,4.16,1.47,3.43,3.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M926.86,1081.74c-.3.9-1.52,1.38-2.64,1.39-.9.01-1.82-.21-2.48-.72-1.39-1.08-.75-3.31,1.24-3.5,1.73-.17,4.42,1.18,3.88,2.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M909.44,1075.96c.62.53.81,1.49.16,1.99-.46.36-1.16.38-1.79.33-1.03-.08-2.19-.38-2.58-1.18-.46-.93.4-1.79,1.49-1.97.95-.16,2.06.25,2.72.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M894.64,1072.19c.5.36.97.85.93,1.4-.04.68-.88,1.18-1.7,1.25s-1.62-.18-2.39-.43c-.77-.25-1.66-.61-1.79-1.29-.16-.83,1.14-1.74,2.04-1.92,1.02-.21,2.18.47,2.91.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M878.59,1070.29c-.63.4-1.52.28-2.29.15-.55-.1-1.1-.2-1.59-.43-1.97-.96-.18-3.05,1.64-2.97,1.55.07,4.03,2.11,2.23,3.25Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampfire);
export default __webpack_public_path__ + "static/media/campfire.384f9ac8731303797df2a31df996b207.svg";
export { ForwardRef as ReactComponent };